/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    select_files_to_upload: 'Select files to upload',
    my_video_shorts: 'BENİM VİDEO KISA KLİPLERİM',
    see_more: 'DAHA FAZLA GÖR',
    no_shorts_found: 'Kısa klip bulunamadı',
    shorts: 'Kısa klipler',
    general_information: 'Genel Bilgi',
    gamification: 'Oyunlaştırma',
    click_to_select_files: 'Dosyaları seçmek için tıklayın',
    selected_files: 'Seçilen Dosyalar',
    uploaded: 'Yüklendi',
    failed: 'Başarısız',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'Sistem, içerik gereksinimlerine göre kuruluşunuzun kitaplığındaki en ilgili belgeleri otomatik olarak analiz eder ve seçer.',
    select_from_library: ' Kitaplıktan Seç',
    search_document: 'Belgelerde Ara...',
    selected: 'Seçildi',
    loading_documents: 'Belgeler yükleniyor...',
    review_generated_content: 'Oluşturulan içeriği incele',
    confirm_and_replace_content: 'İçeriği onayla ve değiştir',
    the_generate_content_will_replace:
      'Oluşturulan içerik, seçili sayfalardaki mevcut metnin yerini alacaktır. Bu değişiklikleri uygulamak istemiyorsanız, önceki adıma geri dönebilirsiniz.',
    pages_to_be_updated: 'Güncellenecek Sayfalar',
    generated_revisions: 'Oluşturulan Revizyonlar',
    lesson_preview: 'Ders Önizlemesi',
    create_new_folder: 'Yeni Klasör Oluştur',
    rename_item: 'Öğeyi Yeniden Adlandır',
    enter_folder_name: 'Klasör adını girin:',
    enter_new_name: 'Yeni adı girin:',
    folder_name: 'Klasör Adı:',
    new_name: 'Yeni Ad',
    move_items: 'Öğeleri Taşı',
    copy_items: 'Öğeleri Kopyala',
    move_here: 'Buraya Taşı',
    copy_here: 'Buraya Kopyala',
    select_destination_library_and_folder: 'Hedef kitaplığı ve klasörü seçin:',
    items_selected: 'Seçilen Öğeler',
    version: 'Sürüm',
    modified_by: 'Değiştiren',
    size: 'Boyut',
    restore: 'Geri Yükle',
    are_you_sure_you_want_to_restore_this_version:
      'Bu sürümü geri yüklemek istediğinizden emin misiniz?',
    this_will_replce_the_current_version_with_the_selected_one:
      'Bu, mevcut sürümü seçilen sürüm ile değiştirir.',
    restore_this_version: 'Bu Sürümü Geri Yükle',
    restore_not_available: 'Geri yükleme mevcut değil',
    version_history: 'Sürüm Geçmişi:',
    by_making_items_public:
      'Öğeleri herkese açık yaparsanız, herkes görebilir. Devam etmeden önce şartlar ve koşulları inceleyin.',
    the_selected_items_will_be_copied:
      'Seçilen öğeler, genel kitaplığınıza kopyalanacak ve herkes tarafından görülebilecek.',
    the_selected_items_will_be_copied_to_org:
      'Seçilen öğeler, kuruluş kitaplığınıza kopyalanacak ve tüm kuruluş üyeleri tarafından görülebilecek.',
    the_selected_items_will_be_copied_to_your_private:
      'Seçilen öğeler, özel kitaplığınıza kopyalanacak ve yalnızca siz görebileceksiniz.',
    loading_organization: 'Kuruluş kullanıcıları yükleniyor...',
    click_download_to_view: "Görmek için İndir'e tıklayın",
    archive_file: 'Arşiv Dosyası',
    no_preview_available: 'Önizleme mevcut değil',
    audit_report: 'Denetim Raporu',
    audit_type: 'İşlem Türü',
    i_agree_to_the_terms_and_conditions: 'Şartlar ve koşulları kabul ediyorum.',
    this_file_is_indexed_for_ai: 'Bu dosya AI için indekslendi.',
    file_is_not_indexed_for_ai: 'Dosya AI için indekslenmedi.',
    no_users_found: 'Kullanıcı bulunamadı',
    no_users_available: 'Kullanıcı mevcut değil',
    add_people: 'Kişi Ekle',
    people: 'Kişiler',
    access_type: 'Erişim Türü',
    no_group_found: 'Grup bulunamadı',
    add_group: 'Grup Ekle',
    groups: 'Gruplar',
    users_top: 'Kullanıcı(lar)',
    confirm_delete: 'Silme Onayı',
    do_you_want_remove: 'Gerçekten kaldırmak istiyor musunuz',
    form_this_documents_permissions: 'bu belgenin izinlerinden?',
    no_users_found_in_this_group: 'Bu grupta kullanıcı bulunamadı',
    add_selected_users: 'Seçilen Kullanıcıları Ekle',
    choose_users_from_the_list: 'Listeden kullanıcı seçin',
    selected_users: 'Seçilen Kullanıcılar',
    archived: 'Arşivlendi',
    request_approval: 'Onay Talep Et',
    document_in_review: 'Belge İnceleniyor',
    approve: 'Onayla',
    reject: 'Reddet',
    comment: 'Yorum:',
    enter_your_commit: 'Yorumunuzu girin...',
    confirm_cancel: 'İptali Onayla',
    upload_3d_zip: '3D Zip Yükle',
    delete_items: 'Öğeleri Sil',
    video_upload_request: 'Video Yükleme Talebi',
    reject_video: 'Videoyu Reddet',
    enter_rejection_reason: 'Reddetme sebebini girin...',
    please_provide_a_reason_for_reejection_this_video:
      'Lütfen bu videoyu reddetme sebebinizi belirtin:',
    generate_trivia_with_ai: 'AI ile Trivia Oluştur',
    select_category: 'Kategori Seç:',
    number_of_question: 'Soru Sayısı',
    generated_questions: 'Oluşturulan Sorular',
    this_will_clear_all_generate_question:
      'Bu, tüm oluşturulan soruları temizleyecektir. Devam edilsin mi?',
    sure_delete: 'Silmek istediğinizden emin misiniz?',
    delete_this_question: 'Bu soruyu silmek istediğinizden emin misiniz?',
    loading_quiz: 'Quiz Yükleniyor...',
    creteing_file: 'Dosya oluşturuluyor',
    opening_desktop_app: 'Masaüstü uygulaması açılıyor',
    this_folder_is_empty: 'Bu klasör boş',
    select_a_competition: 'Bir yarışma seçin...',
    activity_badges: 'Aktivite Rozetleri',
    awarded_every_badges: 'Her 4, 8, 16, 32, 64, 128, 256, 512 girişte verilir',
    learning_badges: 'Öğrenme Rozetleri',
    awarded_every_courses:
      'Her 1, 4, 8, 16, 32, 64, 128 tamamlanan kursta verilir',
    test_badges: 'Test Rozetleri',
    awarded_every_passes_tests:
      'Her 2, 4, 8, 16, 32, 64, 128, 256 geçilen testte verilir',
    assignment_badges: 'Ödev Rozetleri',
    awarded_every_passed_assignments:
      'Her 1, 2, 4, 8, 16, 32, 64, 128 tamamlanan ödevde verilir',
    perfectionism_badges: 'Mükemmeliyet Rozetleri',
    awarded_every_assignments_with_scrore:
      'Her test veya ödevde %90+ puan ile verilir',
    communication_badges: 'İletişim Rozetleri',
    awarded_every_topics_or_comments:
      'Her 2, 4, 8, 16, 32, 64, 128, 256 konu veya yorumda verilir',
    certification_badges: 'Sertifikasyon Rozetleri',
    awarded_every_certificates:
      'Her 1, 2, 4, 8, 16, 32, 64, 128 sertifikada verilir',
    level_name: 'Seviye Adı',
    delete_competition: 'Yarışmayı Sil',
    this_week: 'Bu Hafta',
    this_year: 'Bu Yıl',
    make_organization: 'Organizasyon Yap',
    no_results_found: 'Sonuç bulunamadı',
    no_items_available: 'Öğe yok',
    help_video: 'Yardım Videoları',
    select_a_video_from_the_list:
      'Öğrenmeye başlamak için listeden bir video seçin'
  },
  v4: {
    upload_another_file: 'Upload another file',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files: 'Dosyaları bırakın ve yükleme konumunu seçin.',
    duplicate_lessoon: 'Bu ders zaten kurs içinde mevcut',
    skill_rule_title: 'Lütfen beceri yolu başlığı girin',
    imageCreatorTitle: 'Görsel Oluşturucu',
    isTranslated: 'Çevrildi',
    translationCourseDesc:
      'Kursun çevrilmesi birkaç dakika sürebilir, sabrınız için teşekkür ederiz!',
    translateCourseTip:
      'Tüm dersleri ve sayfaları içeren, orijinalden bağımsız olarak düzenlenebilir çevrilmiş bir kurs oluşturur.',
    translateModalBtn: 'Çevir',
    translationSuccess: '"<0/>" kursu başarıyla çevrildi!',
    translatingCourse: 'Kurs çevriliyor...',
    translateModalTitle: 'Kursu Çevir',
    translateSelectLang: 'Dil seçin',
    fileDeleteconfirm:
      'Bu dosyayı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
    fileDeleteMessage: 'Dosya başarıyla silindi.',
    fileDeleteFailedMessage: 'Dosya silinemedi!',
    fileDelete: 'Bu dosyayı sil',
    certificate_save_btn: 'Sertifika ekle: ',
    maze_path_info: 'Grafikte geçerli bir yol yok!',
    file_size_mb: 'Dosya boyutu 25MB den küçük olmalıdır!',
    reports: {
      products: 'Ürünler',
      users: 'Kullanıcılar',
      ph_username: 'Kullanıcı adına göre ara',
      ph_id: 'Kullanıcı kimliğine göre ara',
      ph_email: 'E-posta adresine göre ara'
    },
    select_upload_section_id: 'Bölüm dosyası gerekli',
    tags_all: 'Tümü',
    delete_file_confirm: 'Bu dosyayı silmek istediğinizden emin misiniz?',
    delete_file_title: 'Dosyayı Sil',
    tooltip_publish: 'Kursu seçilen ayarlarla yayınla',
    tooltip_save: 'Kursu mevcut güncellemelerle kaydet',
    tooltip_next: 'Sonraki kurs ayarına git',
    tooltip_finish: 'Tamamla ve mevcut güncellemeleri kaydet',
    stories_modal: {
      title_upload: 'Hikaye Yükle',
      title_update: 'Hikayeyi Güncelle',
      title_audio: 'Hikaye Ses Dosyası',
      btn_upload: 'Yükle',
      btn_update: 'Güncelle',
      btn_close: 'Kapat',
      btn_cancel: 'İptal',
      lbl_cover: 'Hikaye Kapak Görseli',
      rule_cover: 'Lütfen hikaye kapak görseli yükleyin!',
      lbl_title: 'Hikaye Ses Başlığı',
      rule_title: 'Lütfen ses başlığı girin!',
      lbl_description: 'Hikaye Ses Açıklaması',
      rule_description: 'Lütfen açıklama girin!',
      lbl_file: 'Hikaye Ses Dosyasını Yükle',
      rule_file: 'Lütfen bir ses dosyası yükleyin!',
      rule_file_type: 'Lütfen geçerli bir ses dosyası yükleyin!',
      lbl_select_file: 'Hikaye ses dosyasını seçin',
      msg_valid_file: 'Lütfen geçerli bir ses dosyası seçin!',
      msg_success: 'Hikaye ses dosyası başarıyla yüklendi!',
      msg_failed: 'Medya verisi atanamadı!',
      msg_error: 'Dosya yükleme sırasında hata oluştu!'
    },
    audio_modal: {
      title_upload: 'Yükle',
      title_update: 'Güncelle',
      title_audio: 'Ses Dosyası',
      btn_upload: 'Yükle',
      btn_update: 'Güncelle',
      btn_close: 'Kapat',
      btn_cancel: 'İptal',
      lbl_cover: 'Ses Kapak Görseli',
      rule_cover: 'Lütfen ses kapak görseli yükleyin!',
      lbl_title: 'Ses Başlığı',
      rule_title: 'Lütfen ses başlığı girin!',
      lbl_description: 'Ses Açıklaması',
      rule_description: 'Lütfen açıklama girin!',
      lbl_file: 'Ses Dosyasını Yükle',
      rule_file: 'Lütfen bir ses dosyası yükleyin!',
      rule_file_type: 'Lütfen geçerli bir ses dosyası yükleyin!',
      lbl_select_file: 'Ses dosyasını seçin',
      msg_valid_file: 'Lütfen geçerli bir ses dosyası seçin!',
      msg_success: 'Ses dosyası başarıyla yüklendi!',
      msg_failed: 'Medya verisi atanamadı!',
      msg_error: 'Dosya yükleme sırasında hata oluştu!'
    },
    info_episode: 'Bu bölüm için kapak görseli.',
    btn_delete_episode: 'Bu podcast bölümünü sil',
    btn_edit_marketplace: 'Pazar yeri detaylarını düzenle',
    btn_save_marketplace: 'Mevcut değişiklikleri kaydet',
    btn_ai_podcast: 'Yapay Zeka ile Podcast Bölümü Oluştur',
    btn_upload_podcast: 'Kendi podcast bölümünüzü yükleyin',
    attach_file:
      'Hedef kitlenizle daha fazla içerik paylaşmak için dosya yükleyin',
    fileDownload: 'Bu dosyayı indir',
    singleEpishode: 'Bölüm',
    podcast_music: 'Podcast, Müzik ve Hikayeler',
    publishHeader: 'Podcast, Müzik ve Hikayeleri Yayınla',
    editHeader: 'Podcast, Müzik ve Hikayeleri Düzenle',
    createHeader: 'Podcast, Müzik ve Hikaye Oluştur',
    marketplaceHeader: 'Podcast, Müzik ve Hikaye Pazar Yeri Detayları',
    message_marketplace: 'Lütfen pazar formunu doldurun!',
    create_podcast_live: 'Canlı Podcast ve Müzik',
    create_podcast_custom: 'Özel Podcast ve Müzik',
    create_podcast_stories: 'Hikayeler',
    ai_Assisted_podcast_reation:
      'Yapay Zeka Destekli Podcast ve Müzik Oluşturma',
    publishTitle:
      'Podcast, müzik ve hikayelerinizi herkese açık olarak yayınlayın.',
    customButton: 'Özel Oluştur',
    customTitle: 'Podcast üzerindeki değişiklikleri kaydet',
    updateButton: 'Güncelle',
    createButton: 'Oluştur',
    createNewButton: 'Yeni Oluştur',
    updateTitle: 'Geçerli podcast, müzik ve hikaye detaylarını güncelle',
    createTitle: 'Yeni podcast, müzik ve hikaye oluştur',
    createNewTitle:
      'Bu podcast, müzik ve hikayeye dayalı olarak yeni içerik oluşturulacak.',
    podcastTitle: 'Bölüm Listesi',
    podcastStoryTitle: 'Hikaye Bölüm Listesi',
    podcastToolTipTitle: 'Podcast bölüm listesi',
    uploadAudio: 'Ses Yükle',
    aiAudio: 'Yapay Zeka Sesi',
    emptyPodcast: 'Henüz kayıtlı herhangi bir podcast, müzik veya hikaye yok.',
    emptyStoriesPodcast: 'Henüz eklenmiş hikaye yok.',
    emptyCreatePodcast: 'Ses eklemek için önce bir podcast oluşturun.',
    playPodcast: 'Seçilen podcast, müzik ve hikayeyi oynat',
    pausePodcast: 'Seçilen podcast, müzik ve hikayeyi duraklat',
    selectPodcast: 'Bu podcast, müzik ve hikayeyi seç',
    downloadPodcast: 'Bu sesi indir',
    uploadAudioFile: 'Yeni ses dosyası yükle ve mevcut sesi değiştir',
    deleteConfirm: 'Bu sesi silmek istediğinizden emin misiniz?',
    roomName: 'Podcast Adı',
    addGuestTitle: 'Konuk Konuşmacı Ekle',
    showTime: 'Gösterim Saati',
    startTime: 'Başlangıç Saati',
    endTime: 'Bitiş Saati',
    erorMsgImg: 'Lütfen geçerli bir görsel seçin.',
    failedMsgImg: 'Görsel yüklenemedi, lütfen tekrar deneyin!',
    failedMsgUpload: 'Kapak görseli yüklenemedi!',
    btnCoverUpload: 'Kapak Yükle',
    is_private: 'Gizli',
    to_attach: 'Dosya Ekle',
    file_attached: 'Eklenen Dosyalar',
    main_event: 'Ana Etkinlik',
    event: 'Etkinlik',
    upload_pdf: 'PDF Yükle',
    portrait: 'Dikey',
    landscape: 'Yatay',
    import_from_library: 'Metni medya kütüphanesinden içe aktar',
    question_answer_ai: 'Soru/Cevap AI',
    take_maze: "MetaMaze'i Başlat",
    training: 'Eğitim',
    select_transcribe_locale: 'Transkripsiyon Dili Seç',
    transcribe_limit: 'Lütfen Transkripsiyon Süresini (dakika) Girin',
    not_complete: 'Pazar Yeri Bilgileri Eksik',
    complete: 'Pazar Yeri Bilgileri Tamamlandı',
    not_admin: 'Pazar yerine yayınlamak için yönetici yetkisi gerekli',
    no_course:
      'Pazar yerini etkinleştirmek için başlık girin ve bir görsel seçin',
    scorm_not_complete:
      'SCORM dosyası yüklemek için başlık girin ve görsel seçin',
    not_found_maze: 'MetaMaze Bulunamadı',
    email_require: 'E-posta Adresleri Gerekli',
    poll_required: 'Anket Verisi Gerekli',
    alert: 'Uyarı!',
    warning: 'Dikkat!',
    ok: 'Tamam',
    cancel: 'İptal',
    done: 'Tamamlandı',
    insert: 'Ekle',
    private: 'Özel',
    public: 'Genel',
    no_connection: 'İnternet Bağlantısı Kesildi',
    switch: 'Değiştir',
    share_screen: 'Ekranı Paylaş',
    stop_share_screen: 'Ekran Paylaşımını Durdur',
    share_screen_with_camera: 'Kamera ile Ekranı Paylaş',
    stop_share_screen_with_camera: 'Kamera ile Ekran Paylaşımını Durdur',
    camera_on: 'Kamera Açık',
    camera_off: 'Kamera Kapalı',
    mic_on: 'Sesi Aç',
    mic_off: 'Sesi Kapat',
    fullscreen: 'Tam Ekran',
    live_now: 'Canlı Yayında',
    schedule_on: 'Zamanla:',
    organisations: 'Organizasyonlar',
    org_groups: 'Organizasyon Grupları',
    specific_user: 'Belirli Kullanıcı',
    gif: 'GIF',
    unavailable: 'Kullanılamıyor',
    yes: 'Evet',
    no: 'Hayır',
    event_duration_message: 'En Fazla 300 Dakika (5 Saat)',
    send_email: 'E-posta Bildirimi Gönder',
    admin_only: 'Yalnızca Yönetici',
    join: 'Katıl',
    leave: 'Ayrıl',
    share: 'Paylaş',
    share_text:
      'Bu dosyayı paylaşmak istediğiniz kişinin e-posta adresini yazınız.',
    share_text_title: 'PDF Paylaş',
    share_text_title_txt: 'Metin Paylaş',
    select_users: 'Kullanıcıları Seç',
    delete: 'Sil',
    attachment_event: 'Etkinlik Ekleri:',
    transcribe_limit: 'Transkripsiyon Süresi',
    monthly_transcribe: 'Aylık Transkripsiyon Limiti:',
    enable_ai: 'Yapay Zekayı Etkinleştir:',
    enable_maze: "MetaMaze'i Etkinleştir:",
    media_service: 'Medya Hizmeti',
    allow_others: 'Diğerlerinin Düzenlemesine İzin Ver',
    join_breakout_room: 'Ara Odaya Katıl',
    bio: 'Biyografi',
    linkedin: 'LinkedIn',
    select_org_report: 'Rapor oluşturmak için bir organizasyon bulun ve seçin.',
    org_image_not_found: 'Görsel Bulunamadı',
    insert_text: 'Metin Ekle',
    insert_question_answer: 'Soru/Cevap AI',
    modal_title2: 'Metin Galerisi',
    my_text_library: 'Benim Metin Kütüphanem',
    ai: 'Yapay Zeka',
    public_text_library: 'Genel Metin Kütüphanesi',
    organization_text_library: 'Organizasyon Metin Kütüphanesi',
    no_transcribed_text: 'Transkripte Edilmiş Metin Bulunamadı',
    public_text_not_found: 'Genel Transkripsiyon Metni Bulunamadı',
    org_text_not_found: 'Organizasyon Transkripsiyon Metni Bulunamadı',
    org_video_not_found: 'Video Bulunamadı',
    canva: 'Canva ile Oluştur',
    canva_open: 'Canva editörünü açmak için buraya tıklayın.',
    pdf: 'PDF',
    txt: 'METİN',
    human: 'Premium',
    shared_file: 'Dosyanız başarıyla paylaşıldı.',
    error_shared_file:
      'Dosya paylaşımında bir sorun oluştu. Lütfen tekrar deneyin.',
    publish: 'Yayınla',
    maze_scenes: 'MetaMaze Sahneleri',
    pexel_images: 'Pexel Görselleri',
    group: 'Grup',
    group_name: 'Grup Adı',
    select_group: 'Grup Seç',
    search_maze: 'MetaMaze Ara',
    hosts: 'Sunucular',
    avg_score: 'Ortalama Skor (%)',
    maze_report: 'Maze Raporu',
    maze_view: 'Maze Görünümü',
    title_maze: 'MetaMaze',
    author: 'Yazar',
    match: 'Yol Eşleşmesi',
    preview_mazeTitle: 'Başlık: ',
    other: 'Diğer',
    total: 'TOPLAM',
    report_course: 'KURS',
    report_courses: 'KURSLAR',
    report_event: 'ETKİNLİK',
    report_events: 'ETKİNLİKLER',
    report_maze: 'MAZE',
    report_personalize_learning: 'KİŞİSELLEŞTİRİLMİŞ ÖĞRENME',
    report_live_assessment: 'CANLI DEĞERLENDİRME',
    report_live_assessments: 'CANLI DEĞERLENDİRMELER',
    report_skill_journey: 'BECERİ YOLCULUĞU',
    skill_journey: 'Beceri Yolculuğu',
    skill_journeys: 'Beceri Yolculukları',
    date: 'TARİH: ',
    search_people: 'Kişi Ara',
    passed: 'GEÇTİ',
    failed: 'KALDI',
    item: 'ÖGE',
    type: 'TÜR',
    minimum_pass_score: 'MİNİMUM GEÇME PUANI',
    resources_count: 'KAYNAK SAYISI',
    back: 'GERİ',
    resources: 'KAYNAKLAR',
    time_spent: 'HARCANAN SÜRE (DAKİKA)',
    detail: 'AYRINTI',
    watched_time_mins: 'İZLENEN SÜRE (DAKİKA)',
    personalize_learning: 'Kişiselleştirilmiş Öğrenme',
    result: 'Sonuç',
    assessment_title: 'Başlık',
    marketPlace_graph: 'Pazar Yeri Grafiği',
    attachments: 'Ek Belgeler',
    new_scorm_course: 'Yeni SCORM Kursu Yükle',
    upload_scorm_course: 'SCORM Kursu Yükle',
    new_maze: 'Yeni Bir MetaMaze Oluştur',
    new_skill_journey: 'Bir Yetenek Yolculuğu Oluştur',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'Yetenek Yolculuğu',
    new_discussion_room: 'Yeni Bir Podcast Oluştur',
    title: 'Bugün ne yapmak istiyorsunuz?',
    build_course: 'Kursumu Oluştur',
    live_broadcast: 'Canlı Yayın',
    invite_users: 'Kullanıcıları Kuruluşuma Davet Et',
    build_voice_over: 'Seslendirmemi Oluştur',
    view_reports: 'Raporları Görüntüle',
    upload_media: 'Medya veya Çalışmamı Yükle ve Paylaş',
    main_menu: 'Ana Menü',
    get_started: 'BAŞLA',
    search_group: 'Organizasyon Grubu Ara',
    ai_course: 'Yapay Zeka Kursu',
    search_user: 'Şirket Adı Ara',
    no_maze: 'Şu anda herhangi bir MetaMaze yok.',
    conference_event_title: 'Konferans Etkinlikleri',
    conference_event_subTitle: 'Tamamlanmış Konferans Etkinlikleri',
    conference_event: 'Şu anda konferans etkinliği yok.',
    no_skill: 'Şu anda herhangi bir yetenek yolculuğu yok.',
    no_podcast: 'Şu anda herhangi bir podcast yok.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'Geçmiş Canlı Değerlendirmeler',
    no_live_assessment: 'Şu anda canlı değerlendirme bulunmamaktadır.',
    enrolled_courses: 'Kayıtlı Kurslar',
    my_video_channel: 'Video Kanallarım',
    enrolled_liveEvents: 'Canlı Etkinlikler',
    sharebot: 'Sharebot',
    selected_language: 'Seçilen dil',
    shareSphere_game: 'ShareSphere Oyunu',
    maze: 'MetaMaze',
    skill: 'Yetenek Yolculuğu',
    channel: 'Kanal',
    order: 'Sıra',
    is_record: 'Kayıt',
    no_maze_found: 'MetaMaze bulunamadı.',
    maze_self_limit_reached: 'MetaMaze öz değerlendirme sınırına ulaşıldı.',
    metamaze_two_times: "Bu MetaMaze'i zaten 2 kez tamamladınız.",
    metamaze_two_times_no_result:
      "Bu MetaMaze'i zaten 2 kez tamamladınız. Üçüncü kez tamamlamanız halinde sonuçlarınız kaydedilmeyecektir.",
    scorm_zip: 'SCORM ZIP',
    pass_score: 'Geçme Notu (Minimum Puan)',
    organization: 'Lütfen Bir Kuruluş Seçin',
    pass_score_mark: 'Lütfen 1 ile 100 arasında bir puan girin',
    maze_cloning_success: 'MetaMaze "<0/>" başarıyla kopyalandı!',
    create_certificate: 'Sertifika Oluştur',
    create_badge: 'Rozet Oluştur',
    certificate_added: 'Sertifika Eklendi.',
    badge_added: 'Rozet Eklendi.',
    certificate_warning: 'Sertifika/rozet yayınlandıktan sonra düzenlenemez!',
    created_course_plan:
      'Oluşturduğunuz kursu düzenleyin ve canlı etkinlikleri planlayarak yayınlayın',
    market_place_space: 'Pazar Yeri',
    select_course_language: 'Dil seçin (İsteğe bağlı)',
    select_language: 'Dil Seçin',
    file_upload: 'Dosya Yükle',
    text: 'Buraya metin yazın…',
    attempts_count: 'Kullanıcının Tekrar Deneyebileceği Deneme Sayısı',
    no_of_people_placeholder: 'Kişi Sayısı',
    back_to_maze: 'MetaMaze Senaryosuna Geri Dön',
    edit_maze: "Maze'i Düzenle",
    wait: 'Lütfen bekleyin...',
    retry: 'Yeniden Dene',
    publish_scorm_course: 'SCORM Kursunuzu Yayınlayın',
    publish_maze: "MetaMaze'inizi Yayınlayın",
    import: 'Öğeleri İçe Aktar',
    answer_correct: 'Doğru cevabı seçin',
    author_name: 'Lütfen yazar adını girin',
    select_category: 'Lütfen bir kategori seçin',
    course_outline: 'Lütfen kurs taslağını girin',
    course_obj: 'Lütfen kurs hedeflerini girin',
    course_description: 'Lütfen kurs açıklamasını girin',
    maze_outline: 'Lütfen labirent taslağını girin',
    maze_obj: 'Lütfen labirent hedeflerini girin',
    maze_description: 'Lütfen labirent açıklamasını girin',
    lessons: 'Lütfen ders sayısını girin',
    user_email_require: 'Kullanıcı e-posta adresi gereklidir',
    team_size: 'Lütfen ekip büyüklüğünü girin',
    enter_price: 'Lütfen fiyat girin (5 ve üzeri)',
    input_title_maze: 'Lütfen labirent başlığını girin',
    trainer_bio: 'Lütfen eğitmenin biyografisini girin',
    trainer_linkedin: 'Lütfen eğitmenin LinkedIn bağlantısını girin',
    error_video: 'Lütfen video sayısını girin',
    input_video_link: 'Lütfen video bağlantısını girin',
    number_of_video: 'Video sayısı',
    number_of_lessions: 'Ders sayısı',
    no_of_people_in_conference: 'Konferansa kaç kişi katılıyor?',
    transcribe_settings: 'Transkripsiyon Ayarları',
    transcribe: 'Transkribe Et',
    cloning_maze: 'MetaMaze kopyalanıyor...',
    id_number: 'Kimlik Numarası',
    timezone: 'Zaman dilimi',
    edit_maze: 'Düzenle',
    delete_maze: 'Sil',
    view_maze: 'Görüntüle',
    create_metamaze: 'MetaMaze Oluştur',
    metamaze_scenario: 'MetaMaze Senaryosu',
    publish_metamaze: 'Yayınlama Ayarları',
    search_result: 'Arama Sonucu:',
    search_for: 'Ara',
    search_no_result: '- Sonuç bulunamadı!',
    channel_no_available: 'Kullanılabilir kanal yok!',
    this_card: 'Bu bir karttır',
    course_no_available: 'Mevcut kurs yok!',
    exit_fullscreen: 'Tam ekrandan çık',
    bg_image: 'Arka plan görseli',
    introduction: 'Giriş',
    summary: 'Özet',
    generate_introduction: 'Giriş oluştur',
    generate_summary: 'Özet oluştur',
    bullet_points: 'Madde İşaretleri',
    title_simulation: 'Lütfen simülasyon başlığını girin',
    view_generated_images: 'Oluşturulan görselleri görüntüle',
    image_transparency: 'Görsel şeffaflığı',
    template_bg_color: 'Şablon arka plan rengi',
    select_template_layout: 'Şablon düzeni seçin',
    reload_template: '(Şablonu yeniden yükle)',
    are_you_sure_want_close: 'Kapatmak istediğinizden emin misiniz?',
    all_your_changes_will_be_lost: 'Tüm değişiklikleriniz kaybolacak',
    please_checked_before_generated_video:
      'Lütfen videoyu oluşturmadan önce tüm koşulları işaretleyin',
    voice_must_be_selected: 'Ses seçilmelidir',
    avatar_must_be_selected: 'Avatar seçilmelidir',
    maximum_five_slides_try_again:
      'Dosyanızdan görsel alınırken hata oluştu. Lütfen dosyanızın en fazla 5 slayt içerdiğinden ve her slaytta not olduğundan emin olun. Tekrar deneyin!',
    back_to_upload: 'Yüklemeye geri dön',
    uploading_file_to_server: 'Dosyanız sunucuya yükleniyor',
    extracting_images_from_your_file: 'Dosyanızdan görseller çıkarılıyor',
    upload_your_ppt_or_drag:
      'Sunum dosyanızı (.PPTX) yükleyin veya buraya sürükleyin',
    maximum_five_slides_error:
      'PowerPoint dosyanızın 5 slayttan fazla olmaması ve her bir slaytta not bulunması gerekmektedir. Aksi halde hata oluşur.',
    number_of_questions_generated: 'Oluşturulacak soru sayısı',
    quiz_page_this_cannot_be_done:
      'Bu sayfaya test eklemek istediğinize emin misiniz? Bu işlem geri alınamaz.',
    confirm_selection: 'Seçimi onayla',
    select_quiz_page: 'Test sayfasını seçin',
    lesson_do_you_want_add_this_quiz:
      'Bu testi dersin neresine eklemek istersiniz?',
    beginning_of_lesson: 'Dersin başına',
    end_of_lesson: 'Dersin sonuna',
    currently_active_page: 'Şu anda aktif sayfa',
    finish: 'Bitir',
    upload_selection_file: 'Bölüm dosyasını yükle',
    general_quiz: 'Genel test',
    manage_sequence: 'Sıralamayı yönet',
    save_sequence: 'Sıralamayı kaydet',
    new: 'Yeni',
    in_progress: 'Devam ediyor',
    recommended_course: 'Önerilen Kurs',
    up_coming: 'Yakında',
    past_live: 'Geçmiş Canlı Yayınlar',
    input_your_channel_name: 'Lütfen kanal adınızı girin!',
    organization_place: 'Organizasyon Pazarı',
    marketplace_report: 'Pazar Yeri Raporu',
    story_writing: 'Hikaye Yazımı',
    Ai_quiz: 'AI Testi',
    generate_quiz: 'Test oluştur',
    create_story: 'Hikaye oluştur',
    change_layout_page: 'Bu sayfanın düzenini değiştirmek üzeresiniz',
    change_layout_message:
      'Lütfen unutmayın: Sadece metin, görseller, arka plan ve logo korunacaktır. Diğer tüm öğeler sayfadan silinecektir.',
    reviews: 'Yorumlar',
    tab_attachments: 'Ekler',
    zoom_in: 'Yakınlaştır',
    zoom_out: 'Uzaklaştır',
    zoom_reset: 'Yakınlaştırmayı sıfırla',
    no_attachment: 'Ek yok',
    select_upload_simulation: 'Lütfen bir simülasyon seçin/yükleyin',
    quiz_updated_successfully: 'Test başarıyla güncellendi!',
    quizes: 'Testler',
    trivia: 'Bilgi Yarışması',
    closing: 'Kapatılıyor...',
    products: 'Ürünler',
    ask_questions: 'Buraya bir soru yazın...',
    course_information: 'Kurs Bilgisi',
    course_assistance: 'Kurs Oluşturucu Desteği',
    go_back: 'Geri Dön',
    ai_generate_content_progress: 'İçerik Oluşturma Devam Ediyor',
    view_generate_content: 'Oluşturulan İçeriği Görüntüle',
    generate_error: 'Oluşturma Hatası!',
    confirm_creating_course:
      'Bu içeriği kullanarak kurs oluşturmayı onaylıyor musunuz?',
    generate_content_automatically:
      'Bu işlem, oluşturulan tüm içeriği dersler ve sayfalar olarak kursa otomatik olarak ekler.',
    quiz_created_successfully: 'Quiz başarıyla oluşturuldu!',
    create_quiz: 'Quiz Oluştur',
    quiz_setting: 'Quiz Ayarları',
    please_fill_quiz_setting:
      '* Lütfen Quiz Ayarları’ndaki tüm alanları doldurun',
    question_list: 'Soru Listesi',
    add_quiz_to_page: 'Quiz’i Sayfaya Ekle',
    form_create_question: 'Soru Oluşturma Formu',
    user_information_updated: 'Kullanıcı Bilgileri Güncellendi!',
    your_stripe_activete_to_continue:
      'Stripe hesabınız aktif değil. Devam etmek için bağlayın veya etkinleştirin.',
    connect_tripe: 'Stripe Bağla',
    certificate_sent_sucessfully:
      'Sertifika e-posta adresinize başarıyla gönderildi.',
    error_try_again: 'Hata. Tekrar deneyin!',
    error_delete_channel: 'Kanal silinirken hata oluştu.',
    error_update_sub: 'Abonelik güncellenirken hata oluştu.',
    end_time_cannot_start: 'Bitiş zamanı, başlangıç zamanından önce olamaz.',
    start_date_time_interval: 'Başlangıç tarihi ve saat aralığı gereklidir!',
    podcast_updated_successful: 'Podcast başarıyla güncellendi.',
    podcast_created_successful: 'Podcast başarıyla oluşturuldu.',
    podcast_published_successful: 'Podcast başarıyla yayımlandı',
    podcast_cover_updated: 'Podcast kapak görseli güncellendi',
    new_podcast_details:
      'Yeni giriş bilgileri ile mevcut podcast üzerinde yeni bir podcast oluşturulacak.',
    current_update_podcast:
      'Mevcut podcast, müzik ve hikaye bilgilerini güncelle.',
    create_new_podcast: 'Yeni Podcast Oluştur',
    publish_podcast_public_view: 'Podcast’i herkese açık olarak yayınla.',
    only_allowed_twenty_five_email: 'Yalnızca 25 e-posta adresine izin verilir',
    only_allowed_five_email: 'Yalnızca 5 e-posta adresine izin verilir.',
    cover_is_required: 'Kapak görseli gereklidir.',
    topic_is_required: 'Konu gereklidir.',
    delete_schedule: 'Takvimi Sil',
    make_as_coaching: 'Koçluk Olarak İşaretle',
    manage_category: 'Kategorileri Yönet',
    threshold: 'Eşik Değeri',
    threshold_popup:
      'Yüzde (%) olarak eşik değeri, bu kategori için öneri özelliğinin etkinleşeceği değeri belirtir.',
    list_of_catagory: 'Kategori Listesi',
    category_name: 'Kategori Adı',
    category_threshold: 'Kategori Eşik Değeri',
    play_game: 'Oyun Oyna',
    switching_organization: 'Organizasyon Değiştiriliyor...',
    coaching_session: 'Koçluk Oturumu',
    required_channel_id: 'Kanal Kimliği gerekli!',
    error_occured_try_again: 'Bir hata oluştu. Lütfen tekrar deneyin!',
    please_complete_marketplace_form: 'Lütfen pazar yeri formunu tamamlayın!',
    upload_file_corrupt: 'Yüklenen dosya bozuk.',
    course_not_published: 'Kurs henüz yayınlanmadı!',
    error_request: 'İstek hatası. Lütfen tekrar deneyin!',
    skill_request: 'Lütfen eksik alanları doldurun!',
    error_occured: 'Hata oluştu. Lütfen tekrar deneyin!',
    show_time: 'Saati Göster',
    start_time: 'Başlangıç Zamanı',
    end_time: 'Bitiş Zamanı',
    room_name: 'Podcast Adı',
    add_guest_speaker: 'Konuk Konuşmacı Ekle',
    cover_picture: 'Kapak Resmi',
    guest_speaker: 'Konuk Konuşmacılar',
    see_more: 'Daha Fazla Göster',
    see_less: 'Daha Az Göster',
    background: 'Arka Plan',
    icon: 'Simge',
    icon_size: 'Simge Boyutu',
    icon_color: 'Simge Rengi',
    only_text: 'Yalnızca Metin',
    change_bg: 'Arka plan rengini değiştir',
    bg_color: 'Arka Plan Rengi',
    font_size: 'Yazı Boyutu',
    normal: 'Normal',
    change_color: 'Yazı rengini değiştir',
    slant_text: 'Yazıyı Eğ',
    text_radius: 'Yazı Yuvarlaklığı',
    vertical_align: 'Dikey Hizalama',
    horizontal_align: 'Yatay Hizalama',
    change_icon_color: 'Simge rengini değiştir',
    upload_icon: 'Simge Yükle',
    upload_signature: 'İmza Yükle',
    add_another_sign: 'Başka bir imza ekle',
    name_badges: 'Rozet Adı',
    should_less_150: '150 karakterden az olmalıdır',
    your_badge: 'Rozetiniz',
    do_you_want_delete_badge: 'Bu rozeti silmek istediğinizden emin misiniz?',
    do_you_want_delete_cert:
      'Bu sertifikayı silmek istediğinizden emin misiniz?',
    upload_logo: 'Logo Yükle',
    name_of_cert: 'Sertifika Adı',
    upload_cert: 'Sertifikayı Güncelle',
    your_cert: 'Sertifikanız',
    translate_to: 'Şuna Çevir',
    select_file_attach: 'Eklenecek Dosyayı Seç',
    certificate: 'Sertifika',
    badge: 'Rozet',
    publish_options: 'Yayınlama Seçenekleri',
    publish_skills_journey: 'Beceri Yolculuğunu Yayınla',
    videos: 'Videolar',
    generate_ai_video:
      'Video oluşturma işlemi zaman alabilir. Tamamlandığında e-posta ile bilgilendirileceksiniz.',
    trainer_information: 'Eğitmen Bilgisi',
    promotional_video_link: 'Tanıtım Videosu Bağlantısı',
    please_select: 'Lütfen seçin',
    image_name: 'Görsel adı:',
    image_size: 'Görsel boyutu:',
    charecters_fifteen_less: '15 karakter veya daha az',
    leadership: 'Liderlik',
    text_arc: 'Metin Yayı',
    vertical: 'Dikey',
    horizontal: 'Yatay',
    badge_history: 'Rozet Geçmişi',
    templates: 'Şablonlar',
    sign: 'İmza',
    logo: 'Logo',
    certificate_history: 'Sertifika Geçmişi',
    please_wait: 'Lütfen Bekleyin...',
    information: 'Bilgi',
    support_five_thousand_live_event: 'Etkinlikte 5000 kişiye kadar destekler',
    support_ten_live_event: '10 canlı video katılımcısına kadar destekler',
    we_will_back_participant:
      'Daha fazla katılımcı ile etkinliğe geri döneceğiz.',
    course_objectives: 'Kurs Hedefleri',
    course_outlines: 'Kurs İçeriği',
    price_dollor: 'fiyat (USD)',
    not_completed: 'Tamamlanmadı',
    enable_marketplace: 'Pazar Yerini Etkinleştir',
    enable_course_ai: 'Yapay Zeka ile Kurs Oluşturmayı Etkinleştir',
    enable_report_to_admin: 'Yöneticiye Raporu Göster Etkinleştir',
    enable_white_label: 'White Label Etkinleştir',
    enable_eleven_labs_for_maze_play:
      'Maze Oyunları için Elevenlabs’ı Etkinleştir',
    enable_eleven_labs_for_maze_play_cloned:
      'Kopyalanmış Sesler için Elevenlabs’ı Etkinleştir',
    simulation_quiz: 'Simülasyon Quiz',
    bg_color_setting: 'Arka Plan Rengi Ayarları',
    color_preview: 'Renk Önizlemesi',
    choose_new_color: 'Yeni Renk Seç',
    remove_color: 'Rengi Kaldır',
    apply_color: 'Rengi Uygula',
    elemeent_in_a_sceenario_page:
      'Senaryo sayfasına başka öğe ekleyemezsiniz. Lütfen başka bir sayfa deneyin ya da önce senaryoyu kaldırın.',
    no_data_found: 'Veri Bulunamadı.',
    references: 'Referanslar',
    open_file: 'Dosyayı Aç',
    showing_result: 'Sonuçlar Gösteriliyor:',
    fiften_day_free_trail: '15 Günlük Ücretsiz Deneme',
    your_browser_does_not_support: 'Tarayıcınız ses öğesini desteklemiyor.',
    podcast_desc: 'Podcast Açıklaması',
    input_podcast_desc: 'Lütfen podcast açıklamasını girin',
    podcast_obj: 'Podcast Hedefleri',
    input_podcast_obj: 'Lütfen podcast hedeflerini girin',
    podcast_outline: 'Podcast Taslağı',
    input_podcast_outline: 'Lütfen podcast taslağını girin',
    add_file: 'Dosya Ekle',
    generate_podcast_audio: 'Podcast Sesi Oluştur',
    generate_uploaded_file_input_parameter:
      'Yüklenen dosyalar ve girilen parametreler doğrultusunda içerik oluşturur.',
    go_backe_generation_state: 'İçerik oluşturma durumuna geri dön.',
    create_ai_powered_podcast:
      'Yapay zeka destekli podcast bölümü/leri oluşturun.',
    generate_voice_for_all_podcast:
      'Lütfen tüm podcast bölümleri için ses oluşturun',
    create_podcast_episode: 'Podcast Bölümü Oluştur',
    voice_name: 'Ses Adı',
    input_custom_name: 'Lütfen özel bir ad girin!',
    enter_custom_name: 'Özel ses adı girin',
    upload_complete: 'Yükleme tamamlandı',
    uploading_in_progress: 'Yükleniyor...',
    podcast_stream_content: 'Podcast Yayın İçeriği',
    upload_podcast_cover: 'Lütfen podcast kapağını yükleyin!',
    enter_podcast_name: 'Lütfen podcast adını girin!',
    podcast_topic: 'Podcast Konusu',
    enter_podcast_topic: 'Lütfen podcast konusunu girin!',
    enter_podcast_desc: 'Lütfen podcast açıklamasını girin!',
    number_of_speaker: 'Konuşmacı Sayısı',
    select_the_number_of_speaker: 'Lütfen konuşmacı sayısını seçin!',
    number_of_episode: 'Bölüm Sayısı',
    input_number_of_episode: 'Lütfen bölüm sayısını girin!',
    podcast_length: 'Podcast Süresi',
    select_the_podcast_length: 'Lütfen podcast süresini seçin!',
    short_podcast: 'Kısa (5-10 dk)',
    medium_podcast: 'Orta (15-18 dk)',
    long_podcast: 'Uzun (18+ dk)',
    name_of_host: 'Sunucunun Adı',
    enter_host_name: 'Lütfen sunucunun adını girin!',
    guest_name: 'Konukların Adı',
    enter_guest_name: 'Lütfen konuk adını girin!',
    choose_speaker_tone: 'Konuşmacı Tonunu Seçin',
    enter_speaker_tone: 'Lütfen podcast tonunu seçin!',
    informal: 'Resmi Olmayan',
    formal: 'Resmi',
    serious: 'Ciddi',
    light_humor: 'Hafif Mizah',
    casual: 'Gündelik',
    select_content_source: 'İçerik Kaynağını Seçin',
    from_internet: 'İnternetten',
    upload_pdf_internet: 'PDF veya İç Doküman Yükle',
    note: 'Not:',
    podcast_content_will_be_automatically_generated:
      'Podcast içeriği güvenilir internet kaynaklarından otomatik olarak oluşturulacaktır.',
    upload_or_select_file: 'Lütfen dosya yükleyin veya seçin!',
    podcast_eposode_title: 'Podcast Bölüm Başlığı',
    enter_podcast_title: 'Lütfen bölüm başlığını girin!',
    podcast_episode_des: 'Podcast Bölüm Açıklaması',
    enter_podcast_episode_des: 'Lütfen bölüm açıklamasını girin!',
    voice: 'Ses',
    music: 'Müzik',
    select_music: 'Müzik Seç',
    play_the_music: 'Müziği Çal',
    stop_the_music: 'Müziği Durdur',
    context: 'Bağlam',
    generate_audio_content_selected_voice:
      'İçeriğin sesi seçilen seslere göre oluşturulacaktır.',
    required_field_before_submitting:
      'Lütfen göndermeden önce tüm zorunlu alanları doldurun.',
    regenerate_voice: 'Sesi Yeniden Oluştur',
    generate_voice: 'Sesi Oluştur',
    your_browser_does_not_suppot: 'Tarayıcınız ses öğesini desteklemiyor.',
    are_sure_leave_podcast: 'Podcast’ten ayrılmak istediğinize emin misiniz?',
    broadcast_ongoing:
      'Yayın devam ediyor. Bu sayfadan ayrılmak istediğinize emin misiniz?',
    brodcaster_unavailable: 'Şu anda yayıncı kullanılamıyor.',
    setting_calender_for_booking: 'Rezervasyon için Takvim Ayarlanıyor',
    add_calender: 'Takvim Ekle',
    waiting_join_host: 'Sunucunun katılması bekleniyor...',
    no_reviews_found: 'Yorum bulunamadı.',
    rated_already: 'Bu canlı etkinliği zaten puanladınız.',
    downlink_png: 'png_indir',
    downlink_jpg: 'jpg_indir',
    donwload_file_format: 'Lütfen indirmek istediğiniz dosya formatını seçin.',
    crashed_event:
      'Bu etkinlik çöktü. Yeni bir etkinlik oluşturmanız gerekiyor. Verdiğimiz rahatsızlıktan dolayı özür dileriz.',
    prompt: 'İpucu:',
    generated_image: '🚀 Görüntü oluşturuluyor... Lütfen bekleyin.',
    download_add: 'Tümünü indir',
    setting_generator: 'Oluşturucu Ayarı',
    enter_image_prompt: 'Lütfen bir görsel komutu girin',
    image_prompt: 'Görsel komutunu girin',
    negative_prompt: 'Olumsuz Komut',
    negative_image_prompt: 'Olumsuz görsel komutunu girin',
    number_output: 'Çıktı Sayısı',
    enter_number_output: 'Lütfen çıktı sayısını girin',
    image_style: 'Lütfen görsel stili seçin',
    output_format: 'Çıktı Formatı',
    seeds: 'Tohumlar',
    enter_seeds: 'Lütfen tohum sayısını girin',
    performance_mode: 'Performans Modu',
    quality: 'Kalite',
    speed: 'Hız',
    balanced: 'Dengeli',
    guidance_scale: 'Yönlendirme Ölçeği',
    enter_guidance: 'Lütfen yönlendirme ölçeğini girin',
    select_image: 'Lütfen görsel seçin.',
    image_prmt: 'Görsel Komutu',
    generate_image_list_empty: 'Oluşturulan görsel listesi boş.',
    knowledge_center_tooltrip_des:
      'Genel bilgi soruları dahil geniş bir yelpazedeki sorulara net ve bağlamsal olarak doğru yanıtlar alın. Yanıtlar, çeşitli internet metinlerinden eğitilmiş bir yapay zeka modelinden elde edilir.',
    contexts: 'Bağlamlar',
    ai_processing_video_sharebot:
      'Videonun yapay zeka ile işlenmesi yaklaşık 24 saat sürecek ve Sharebot’ta yansıtılacaktır.',
    remove_sharebot_video: `Videonun Sharebot referansını kaldırmak istiyorsanız, ilgili transkripti ve videoyu silin.`,
    remove_sharebot_video_audio:
      'Transkripti silmek, video/ses referansını Sharebot’tan kaldıracaktır ancak video medya kitaplığında/kanalda kalacaktır.',
    monthly_live_stream:
      'Aylık canlı yayın sınırınızı değiştirmek için lütfen iletişime geçin',
    monthly_transcribe_limit:
      'Aylık yazıya dökme sınırınızı değiştirmek için lütfen iletişime geçin',
    must_be_one_to_three_hundred: '1 ile 300 dakika arasında olmalıdır.',
    all_field_required: 'Tüm alanlar zorunludur.',
    duration_minute: 'Süre (en fazla 300 dakika)',
    gender: 'Cinsiyet',
    select_gender: 'Cinsiyet Seç',
    accent: 'Aksan',
    select_accent: 'Aksan Seç',
    create_voice: 'Ses Oluştur',
    enter_voice_name: 'Ses Adını Girin',
    select_voice_gender: 'Lütfen ses cinsiyetini seçin',
    upload_voice: 'Sesinizi Yükleyin',
    upload_voice_mp_three: 'Sesinizi yükleyin (.mp3)',
    cloned_voice: 'Klonlanmış Sesler',
    voice_type: 'Ses Türü',
    select_voice_type: 'Ses Türünü Seçin',
    sharelook_stand: 'Standart',
    sharelook_premium: 'Premium',
    sharelook_custum_voice: 'Özel (Ses Klonlama)',
    create_auto_flow: 'Otomatik Akış Oluştur',
    how_many_layers: 'Kaç katman',
    verify_selection: 'Seçimi Doğrula',
    uploaded_successful: 'Başarıyla yüklendi',
    upload_failed: 'Yükleme başarısız oldu',
    upload_only_five_mb: 'İçerik Yükleyin (PDF dosyaları, en fazla 5)',
    docs_from_org_library: 'Kuruluş Kitaplığından Belge Kullan',
    failed_maze_generate: 'Labirent oluşturulamadı. Lütfen tekrar deneyin.',
    generate_metamaze: 'MetaMaze Oluşturuluyor...',
    metamaze_being_generated:
      'MetaMaze’iniz oluşturuluyor. İşlem tamamlandığında e-posta ile bilgilendirileceksiniz.',
    metamaze_generate_successfully: 'MetaMaze Başarıyla Oluşturuldu!',
    metamaze_with_proceed: 'Artık MetaMaze ile devam edebilirsiniz.',
    ai_metamaze_generate: 'Yapay Zekâ ile MetaMaze Oluşturma',
    what_kind_maze_create: 'Ne tür bir labirent oluşturmak istersiniz?',
    manual_metamaze_creation: 'Manuel MetaMaze Oluşturma',
    manually_maze_customizing_scnario:
      'Senaryo ve seçenek ağacını özelleştirerek manuel olarak bir labirent oluşturun',
    maze_ai_generated: 'Yapay Zekâ ile otomatik labirent oluştur',
    unmark_deadend: 'Çıkmaz olarak işareti kaldır',
    mark_deadend: 'Çıkmaz olarak işaretle',
    select_multiple_image_for_scenario:
      'Senaryo için birden fazla görsel seçebilirsiniz.',
    select_your_image: 'Seçtiğiniz görseller',
    click_to_preview: 'Önizleme için tıklayın',
    are_you_sure_delete_image: 'Bu görseli silmek istediğinizden emin misiniz?',
    select_image_from_library: 'Medya Kitaplığından Görsel Seçin',
    uploading_video: 'Video yükleniyor...',
    tree_node_type: 'Ağaç Düğümü Türü',
    correct_option_scenario: 'Doğru Seçenek veya Senaryo',
    incorrect_option: 'Yanlış Seçenek',
    option_scenario_without_text: 'Metinsiz Seçenek veya Senaryo',
    dead_end: 'Çıkmaz (Kırmızı Kenarlık)',
    correct_path: 'Doğru Yol',
    incorrect_path_not_selected_correct_option_path:
      'Yanlış Yol / Doğru seçeneğin seçilmediği yol.',
    double_click_on_tree_node:
      'Bir ağaç düğümüne çift tıkladığınızda, metin düzenleyici o düğümün içeriğini görüntülemek için otomatik olarak kaydırılır.',
    add_scenario: 'Senaryo Ekle',
    add_option: 'Seçenek Ekle',
    an_error_occured: 'Bir hata oluştu:',
    download_summary: 'Özeti İndir',
    step_wise_analysis: 'Adım Adım Analiz',
    step: 'Adım',
    upload_csv_file: 'CSV Dosyası Yükle',
    download_template_to_import: 'İçe aktarmak için örnek şablonu indir',
    please_input_email: 'Lütfen e-posta girin.',
    email_at_least_three_characters: 'E-posta en az 3 karakter olmalıdır.',
    email_cannot_be_empty: 'E-posta boş olamaz.',
    input_email_in_new_line:
      'Lütfen e-postaları girin (her satıra bir e-posta)',
    role: 'Rol',
    select_role: 'Lütfen bir Rol seçin',
    select_group: 'Lütfen bir Grup seçin',
    identification_number: 'Kimlik numarası (İsteğe bağlı)',
    add_identification_number: 'Lütfen bir Kimlik numarası ekleyin',
    pie_chart_of_all_categories:
      'Sharelook’ta kullanımına göre tüm kategorilerin pasta grafiği.',
    total_sharesphere_question_answered_by_users:
      'Geçerli organizasyonda kullanıcılar tarafından cevaplanan toplam ShareSphere soruları ve başarı/başarısızlık sonuçları.',
    voice_style_over_the_text: `Yazdığınız metin üzerinde birçok ses stili kullanabilirsiniz, bla bla bla. Lorem Ipsum matbaacılık ve dizgi endüstrisinin sahte metnidir. 1500’lü yıllardan beri kullanılmaktadır.`,
    input_your_question: 'Lütfen sorunuzu girin!',
    make_me_sales_manager: 'örn: Beni satış müdürü yapan şey nedir?',
    enter_the_number_relevant_document: 'İlgili belge sayısını girin',
    please_wait_loading_result: 'Lütfen bekleyin, sonuçlar yükleniyor...',
    no_result_found: 'Sonuç bulunamadı, daha fazla soru sormayı deneyin',
    browser_doesnot_support_iframes: 'Tarayıcınız iframe desteği vermiyor',
    total_duration: 'Toplam Süre',
    number_of_messages: 'Mesaj Sayısı',
    search_result: 'Arama Sonuçları',
    count_result: '(1244 sonuç)',
    your_other_interests: 'Diğer İlgi Alanlarınız',
    your_total_score: 'Toplam Puanınız',
    add_a_question: '+soru ekle',
    travia_question_empty: 'Travia soru listesi boş.',
    video_generation_is_on_queue: 'Video üretiminiz sıraya alındı!',
    checking_video_status: 'Video durumu kontrol ediliyor...',
    total_quizzes: 'Toplam Testler',
    number_of_votes: 'Oy Sayısı',
    total_events: 'Toplam Etkinlikler',
    number_of_rates: 'Puan Sayısı',
    number_of_likes: 'Beğeni Sayısı',
    all_courses: 'Tüm Kurslar',
    total_questions: 'Toplam Soru',
    no_skill_journey: 'Herhangi bir yetenek yolculuğu mevcut değil!',
    search_no_results: '- sonuç bulunamadı!',
    no_image_generated: 'Görüntü oluşturulmadı!',
    all_topic_in_this_lesson:
      'Bu dersteki tüm konular silinecek. Bu işlem geri alınamaz.',
    content_has_been_generated: 'Bu konu için içerik oluşturuldu.',
    update_course_template: 'Kurs Şablonunu Güncelle',
    add_course_template: 'Kurs Şablonu Ekle',
    create_course_now: 'Şimdi Kurs Oluştur',
    preview_course: 'Kursu Önizle',
    layout: 'Düzen',
    import_from_youtube: 'YouTube’dan içe aktar',
    my_media_library: 'Medya Kütüphanem',
    bg_added: 'Arka plan eklendi',
    add_bg: 'Arka Plan Ekle',
    booked_schedule: 'Rezervasyon Yapılmış Takvim',
    add_schedule: 'Takvim Ekle',
    are_you_delete_schedule: 'Bu takvimi silmek istediğinizden emin misiniz?',
    add_task: 'Görev Ekle',
    update_calender: 'Takvimi Güncelle',
    manage_cookies: 'Çerezleri Yönet',
    cookie_banner_text:
      'Tarama deneyiminizi geliştirmek, web sitesi trafiğini analiz etmek ve içeriği kişiselleştirmek için çerezleri kullanıyoruz. Gizliliğiniz bizim için önemlidir.',
    accept_all_cookies: 'Tüm Çerezleri Kabul Et',
    reject_all: 'Tümünü Reddet',
    customize: 'Özelleştir',
    cookie_preferences_title: 'Çerez Tercihleri ve Gizlilik Ayarları',
    privacy_subtitle:
      'Gizliliğiniz bizim için önemlidir. Hangi çerezleri kabul etmek istediğinizi seçin. Bu ayarları istediğiniz zaman değiştirebilirsiniz.',
    save_choices: 'Seçimlerimi Kaydet',
    strictly_necessary: 'Kesinlikle Gerekli',
    strictly_necessary_desc:
      'Bu çerezler, web sitesinin düzgün çalışması için gereklidir. Sayfa gezintisi, form gönderimleri ve güvenli alanlara erişim gibi temel işlevleri sağlar. Bu çerezler olmadan web sitesi düzgün çalışamaz.',
    analytics_performance: 'Analitik & Performans',
    analytics_performance_desc:
      'Bu çerezler, ziyaretçilerin web sitesiyle nasıl etkileşimde bulunduğunu anlamamıza yardımcı olur ve bilgileri anonim olarak toplar ve raporlar. Bu, web sitesinin performansını ve kullanıcı deneyimini iyileştirmemize yardımcı olur.',
    advertising_marketing: 'Reklam & Pazarlama',
    advertising_marketing_desc:
      'Bu çerezler, reklam mesajlarını sizin için daha uygun hale getirmek için kullanılır. Aynı reklamın sürekli görünmesini engeller ve reklamverenler için reklamların doğru görüntülenmesini sağlar.',
    tracking_social: 'Takip & Sosyal Medya',
    tracking_social_desc:
      'Bu çerezler, sosyal medya özellikleri ve kişiselleştirilmiş içerik gibi gelişmiş işlevsellik ve kişiselleştirme sağlar. Bunlar bizim tarafımızdan veya üçüncü taraf sağlayıcılar tarafından ayarlanabilir.',
    functional: 'Fonksiyonel',
    functional_desc:
      'Bu çerezler, sohbet desteği, canlı yardım ve web sitesi deneyiminizi iyileştiren diğer etkileşimli özellikler gibi gelişmiş işlevsellik sağlar.',
    your_rights: 'Haklarınız:',
    rights_description:
      'Rızanızı istediğiniz zaman geri çekebilir, verilerinize erişebilir veya silinmesini talep edebilirsiniz.',
    withdraw_consent: 'Tüm Rızayı Geri Çek',

    how_many_options: 'Kaç Seçenek',
    add_content: 'İçerik Ekle',
    downloads_center: 'İndirme Merkezi',
    sharelook_help_center: 'Sharelook Yardım Merkezi',
    channel_outline: 'Kanal Taslağı',
    channel_objectives: 'Kanal Hedefleri',
    no_sop_available: 'Mevcut SOP listesi yok.',
    generate_world_summary: 'Senaryo Oluştur',
    world_scenario: 'Gerçek Dünya Senaryosu',
    drag_icon_hint: 'İpucu: İkonu konumlandırmak için tuval üzerine sürükleyin',
    drag_text_hint: 'İpucu: Metni konumlandırmak için tuval üzerine sürükleyin',
    edit_badge: 'Rozeti Düzenle',
    create_new_badge: 'Yeni Rozet',
    select_video_preview: 'Önizleme için video seçin',
    certificate_title_required: 'Sertifika Başlığı zorunludur',
    discard_changes: 'Değişiklikleri At',
    edit_certificate: 'Sertifikayı Düzenle',
    add_another_logo: 'Başka Logo Ekle',
    optional: 'Opsiyonel',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'Yeni Görev Oluştur',
    quest_filter_title: 'Görev',
    sharelook_assistance: 'Sharelook Yardımı',
    upload_scorm_zip: 'Scorm Zip Yükle',
    only_letters_numbers_space_dot_allowed:
      'Sadece harfler, sayılar, boşluk ve nokta kabul edilir!',
    video_playing: 'Oynatılıyor',
    course_price_message:
      '*Kurs yalnızca organizasyon içindeki kullanıcılara yayınlanacak ve pazarda satılamaz.',
    lesson_must_be_positive: 'Ders sayısı 1’den büyük olmalıdır',
    btn_proceed: 'İlerle',
    rule_select_music: 'Lütfen müzik seçin',
    course_info: 'Kurs Bilgisi',
    content_selection: 'İçerik Seçimi',
    course_content_source: 'Kurs İçeriği Kaynağı',
    choose_how_to_source:
      'Bu kurs için içerik kaynağını nasıl seçmek istiyorsunuz:',
    automatic_selection: 'Otomatik Seçim',
    system_will_automatically_select_relavant_documents:
      'Sistem, kitaplığınızdan ilgili belgeleri otomatik olarak seçecektir',
    manual_selection: 'Manuel Seçim',
    choose_specific_documents_from_your_library:
      'Kitaplığınızdan belirli belgeleri seçin',
    upload_files: 'Dosya Yükle',
    upload_new_documents:
      'Yeni belgeler yükle (PDF, DOC, DOCX, PPT, PPTX, TXT) - Maksimum 5 dosya',
    file: 'dosya',
    ready_to_upload: 'yüklemeye hazır',
    clear_all: 'Tümünü Temizle',
    confirm_course_wide_premiew: 'Kurs Genel Önizlemeyi Onayla',
    generate_course_preview: 'Kurs Önizlemesi Oluştur',
    instructions_across_the_course_to_generate:
      'Talimatlarınızı kurs genelinde uygulayarak bir önizleme oluşturacağız. Önce her şeyi gözden geçirin, ardından değişiklikleri saklayın veya iptal edin.',
    instruction_to_preview_course_wide: 'Kurs genel önizleme talimatları:',
    edit_content: 'İçeriği Düzenle',
    manage_course_template: 'Kurs Şablonunu Yönet',
    undo: 'Geri Al',
    apply_changes: 'Değişiklikleri Uygula',
    characters: 'karakter',
    apply_all: 'Tümüne Uygula',
    apply_to_all: 'Hepsine Uygula',
    use_this_content: 'Bu İçeriği Kullan',
    original: 'Orijinal',
    edited: 'Düzenlenmiş',
    edited_content_preview: 'Düzenlenmiş İçerik Önizlemesi',
    apply_edits_to_all_topices: 'Tüm konulara düzenlemeyi uygula mı?',
    current_editing_instructions_across_the_whole_course:
      'Bu, mevcut düzenleme talimatlarınızı tüm kurs boyunca uygulayacaktır. Kaydetmeden önce birleşik önizlemeyi inceleyebilirsiniz.',
    edit_content_instructions: 'İçerik Düzenleme Talimatları',
    generate_content_for_this_topic_instruction:
      'Bu konu için talimatlarınızı kullanarak içerik oluşturun',
    descrip_edit_content:
      'Bu içeriği nasıl düzenleyeceğinizi açıklayın (ör. kısalt, basitleştir, yeniden yaz)',
    try_short_clear_direcctives:
      'Kısa ve net yönergeler deneyin. Örnek: “100 kelimeye indir, ana noktaları koru”, “dili basitleştir”, “daha öz ve gereksizleri kaldır”.',
    we_preserve_the_core_meaning:
      'Talimatlarınızı uygularken ana anlamı koruyoruz.',
    feedback_optional: 'Geri Bildirim (Opsiyonel)',
    write_your_feedback_here: 'Geri bildiriminizi buraya yazın',
    from_web: 'Web’den',
    from_desktop: 'Masaüstünden',
    pleae_wait_processing: 'Lütfen işlem yapılırken bekleyin...',
    create_simulation_from_screen_capture:
      'Ekran Görüntüsünden Simülasyon Oluştur',
    sharelook_not_found: 'ShareLook Bulunamadı',
    sharelook_screen_capture_application_not_be_opened:
      'ShareLook Ekran Yakalama uygulaması açılamadı. Bilgisayarınıza yüklü olmayabilir.',
    download_sharelook: 'ShareLook İndir',
    launch_sharelook_application: 'ShareLook Uygulamasını Başlat',
    this_will_open_the_sharelook_application_for_screen_capture:
      'Bu, ekran yakalama için ShareLook uygulamasını açacaktır.',
    sharelook_dosenot_open:
      'ShareLook açılmıyorsa, bilgisayarınıza yüklü olmayabilir.',
    open_sharelook: 'ShareLook’u Aç',
    download_app: 'Uygulamayı İndir',
    background_image_setting: 'Arka Plan Görsel Ayarları',
    current_image: 'Mevcut Görsel',
    change_image: 'Görseli Değiştir',
    remove_image: 'Görseli Kaldır',
    no_background_image_selected: 'Arka plan görseli seçilmedi',
    add_image: 'Görsel Ekle',
    this_will_open_for_screen_recording:
      'Bu, ekran kaydı için ShareLook uygulamasını açacaktır.',
    ai_image_generation: 'AI Görsel Oluşturma',
    image_edit: 'Görsel Düzenleme',
    text_to_image: 'Metni Görsele Dönüştür',
    output_gallary: 'Çıktı Galerisi',
    instant_generation: 'Anında Oluşturma Hazır',
    prompt_and_unleash_the_power: 'Komutu girin ve gücü serbest bırakın',
    use_this_image: 'Bu Görseli Kullan',
    error_generating: 'Oluşturma sırasında hata oluştu.',
    generation_tips: 'Oluşturma İpuçları',
    detailed_descriptions_for_more_accurate_results:
      'Daha doğru sonuçlar için detaylı açıklamalar kullanın',
    reference_image: 'Referans Görsel',
    select_pixel_image: 'Piksel Görsel Seç',
    max_mb: 'Maks 50MB',
    please_enter_text_to_appear_image: 'Görselde görünecek metni girin',
    enter_text_to_apear_in_the_image: 'Görselde görünecek metni girin',
    generate_image: 'Görsel Oluştur',
    prompt_assistant: 'Komut Asistanı',
    generate_image_using_suggested_prompt:
      'Önerilen komutu kullanarak görsel oluştur',
    talk_to_ai_about_the_image_generate:
      'Oluşturmak istediğiniz görsel hakkında AI ile konuşun',
    ask_for_prompt_suggestions: 'Komut önerileri isteyin...',
    enter_a_search_term_to_find_stock_images:
      'Stok görselleri bulmak için arama terimi girin',
    choose_your_content_source: 'İçerik kaynağınızı seçin:',
    upload_new_document_from_your_device: 'Cihazınızdan yeni belge yükleyin',
    automatic_library_selection: 'Otomatik Kütüphane Seçimi',
    system_automatically_selects_relevant_document:
      'Sistem ilgili belgeleri otomatik olarak seçer',
    manual_library_selection: 'Manuel Kütüphane Seçimi',
    generate_content: 'İçerik Oluştur',
    add_to_current_page: 'Mevcut Sayfaya Ekle',
    generate_bullet_points: 'Madde İşaretleri Oluştur',
    generating: 'Oluşturuluyor',
    this_may_take_a_few_moments: 'Bu biraz zaman alabilir',
    apply_to_page: 'Sayfaya Uygula',
    scenario_escription: 'Senaryo Açıklaması:',
    feedback: 'Geri Bildirim',
    form_mode: 'Form Modu',
    chat_mode: 'Sohbet Modu',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'Bu, seçilen hikayenin devamını AI kullanarak oluşturacaktır.',
    continue_this_story_question: 'Bu hikayeye devam etmek ister misiniz?',
    continue_this_story: 'Bu Hikayeye Devam Et',
    what_will_happen: 'Ne olacak:',
    the_ai_will_analyze_the_existing_story_content:
      'AI mevcut hikaye içeriğini analiz edecektir',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'Aynı ton ve stile uygun doğal bir devam oluşturun',
    create_new_content_that_build_upon_the_current_narrative:
      'Mevcut anlatıya dayalı yeni içerik oluşturun',
    this_process_may_take_a_few_moments_to_complete:
      'Bu işlem tamamlanması birkaç dakika sürebilir.',
    no_existing_stories_found_for_this_course:
      'Bu kurs için mevcut hikaye bulunamadı.',
    create_your_first_story: 'İlk Hikayenizi Oluşturun',
    existing_stories: 'Mevcut Hikayeler',
    create_new_story: 'Yeni Hikaye Oluştur',
    tone: 'Ton',
    style: 'Stil',
    genre: 'Tür',
    loading_your_stories: 'Hikayeleriniz yükleniyor...',
    edit_story: 'Hikayeyi Düzenle',
    story_preferences: 'Hikaye Tercihleri',
    please_input_your: 'Lütfen giriniz',
    add_character_names_and_press_enter:
      'Karakter isimlerini ekleyin ve Enter’a basın',
    select_or_type_your: 'Seçin veya yazın',
    enter_your: 'Giriniz',
    position_of_the_story_in_the_lesson:
      'Hikayenin dersteki konumu. Hikaye, belirtilen konuma bir blok olarak eklenecektir.',
    save_previous_content_on_the_pages: 'Sayfalardaki önceki içeriği kaydet',
    the_existing_content_in_the_selected_pages:
      'Seçilen sayfalardaki mevcut içerik, oluşturulan hikaye ile değiştirilecektir.',
    real_world_scenario: 'Gerçek Dünya Senaryosu',
    add_optional_instructions:
      'Opsiyonel talimatlar ekleyin (ton, uzunluk, hedef kitle, vb.)',
    ready_to_enerate_your_real_world_scenario:
      'Gerçek Dünya Senaryonuzu Oluşturmaya Hazır',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      '"Gerçek Dünya Senaryosu Oluştur"u tıklayın ve ders içeriğinize dayalı gerçekçi bir senaryo oluşturun.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'AI ders konunuzu ve içeriğinizi analiz edecektir',
    generate_a_practical_real_world_scenario:
      'Pratik bir gerçek dünya senaryosu oluşturun',
    you_can_then_edit_and_customize_the_result:
      'Daha sonra sonucu düzenleyebilir ve özelleştirebilirsiniz',

    add_it_as_a_new_page_to_your_lesson:
      'Bunu dersinize yeni bir sayfa olarak ekleyin',
    regenerate_with_instructions: 'Talimatlarla Yeniden Oluştur',
    add_real_world_scenario: 'Gerçek Dünya Senaryosu Ekle',
    generate_real_world_scenario: 'Gerçek Dünya Senaryosu Oluştur',
    simulation_has_been_stopped: 'Simülasyon durduruldu!',
    loading_simulation: 'Simülasyon yükleniyor...',
    you_have_exhausted_all_the_attempts: 'Tüm denemelerinizi kullandınız',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'Bu sayfadaki senaryoyu inceleyin ve aşağıdaki seçeneklerden doğru cevabı seçin.',
    attempts_limit_reached:
      'Deneme sınırına ulaşıldı. Tekrar oynayabilirsiniz ancak puanınız kaydedilmeyecektir.',
    play_again: 'Tekrar Oyna',
    import_music_from_computer: 'Bilgisayardan müzik içe aktarın.',
    more: 'daha fazla',
    no_badge_yet: 'Henüz rozet yok',
    competition_filter: 'Yarışma Filtresi',
    global_leaderboard: 'Global Lider Tablosu',
    placeholder_for_the_global_leaderboard:
      'Bu, Global Lider Tablosu için yer tutucudur.',
    badge_editor: 'Rozet Düzenleyici',
    adjust_the_appearance_of_this_badge_icon:
      'Bu rozet simgesinin görünümünü ayarlayın. Değişiklikler yalnızca bu rozet için geçerlidir.',
    badge_style: 'Rozet Stili',
    the_image_must_be_pixels: 'Resim 200x200 piksel olmalıdır.',
    badge_name: 'Rozet Adı',
    badge_descrription: 'Rozet Açıklaması',
    enter_badge_criteria: 'Rozet kriterlerini girin',
    discard: 'İptal',
    badge_enable: 'Rozetleri Etkinleştir',
    award_users_with_badges_to_highlight_the_milestones:
      'Kullanıcılara öğrenme yolculuklarındaki kilometre taşlarını vurgulamak için rozet verin.',
    badge_types: 'Rozet Türleri',
    enable_or_disable_specific_badge_types_for_your_users:
      'Kullanıcılarınız için belirli rozet türlerini etkinleştirin veya devre dışı bırakın.',
    levels_enabled: 'Seviyeler Etkin',
    level_rules: 'Seviye Kuralları',
    points: 'Puanlar',
    add_new_level: 'Yeni Seviye Ekle',
    add_level: 'Seviye Ekle',
    points_enabled: 'Puanlar Etkin',
    learning_activities_and_encourage_healthy_competition:
      'Farklı öğrenme aktiviteleri için kullanıcılara puan verin ve sağlıklı rekabeti teşvik edin.',
    award_points: 'Puan Ver',
    the_following_equates_the_value_of_one_item_completion:
      'Aşağıdakiler bir öğe tamamlamanın değerine eşittir',
    general: 'Genel',
    others: 'Diğerleri',
    certificate: 'Sertifika',
    quiz_passed: 'Test geçti',
    tip_approved: 'İpucu Onaylandı',
    tip_liked: 'İpucu Beğenildi',
    rewards: 'Ödüller',
    offer_discounts_when_learners_achieve:
      'Öğrenciler belirli puan, rozet veya seviyeye ulaştığında indirim sunun.',
    give_rewards: 'Ödül Ver',
    discount_course_purchases_by: 'Kurs satın alımlarında indirim',
    with_points_more_than: 'puanı aşan',
    with_badges_more_than: 'rozet sayısı fazla olan',
    with_level_upwards_more_than: 'seviyesi yüksek olan',
    leaderboard: 'Lider Tablosu',
    leaderboard_enabled: 'Lider Tablosu Etkin',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'Lider tabloları, kullanıcıların puanlarını başkalarıyla karşılaştırarak öğrenme ilerlemelerini görmelerini sağlar.',
    show_levels: 'Seviyeleri Göster',
    show_points: 'Puanları Göster',
    show_badges: 'Rozetleri Göster',
    show_courses: 'Kursları Göster',
    show_certificates: 'Sertifikaları Göster',
    leaderboard_settings: 'Lider Tablosu Ayarları',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'Öğrenen motivasyonunu artırmak için ilgi çekici lider tablosu deneyimleri oluşturun.',
    award_users_with_points_for_different_learning_activities:
      'Farklı öğrenme aktiviteleri için kullanıcılara puan verin.',
    badge_set: 'Rozet Seti',
    choose_the_type_of_badges_your_users:
      'Kullanıcılarınızın öğrenirken kazanacağı rozet türünü seçin.',
    levels: 'Seviyeler',
    Levels_represent_the_stages:
      'Seviyeler, kullanıcıların öğrenme yolculuğundaki aşamaları temsil eder.',
    enabled: 'Etkin',
    disabled: 'Devre Dışı',
    quick_select: 'Hızlı Seçim',
    yesterday: 'Dün',
    last_week: 'Geçen Hafta',
    Last_month: 'Geçen Ay',
    last_quarter: 'Geçen Çeyrek',
    historical_leaderboard: 'Tarihi Lider Tablosu',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'Performansınızı takip edin ve akranlarınız arasındaki sıralamanızı görün',
    time_period: 'Zaman Aralığı',
    page_of: 'Sayfa 1 / 1',
    edit_competition: 'Yarışmayı Düzenle',
    create_competition: 'Yarışma Oluştur',
    arrow_right: 'sağ-ok',
    update_competition: 'Yarışmayı Güncelle',
    competition_title: 'Yarışma Başlığı',
    enter_competition_title: 'Yarışma başlığını girin',
    enter_competition_description: 'Yarışma açıklamasını girin',
    leaderboard_skill: 'Beceri',
    select_a_skill: 'Bir beceri seçin',
    no_skills_found: 'Beceri bulunamadı',
    competition_period: 'Yarışma Dönemi',
    add_badge_rule: 'Rozet Kuralı Ekle',
    create_badge: 'Rozet Oluştur',
    add_level_rule: 'Seviye Kuralı Ekle',
    selected_participants: 'Seçilen Katılımcılar',
    no_participants: 'Katılımcı yok',
    start_end_date: 'Başlangıç–Bitiş Tarihi',
    created_date: 'Oluşturan',
    new_competition: 'Yeni Yarışma',
    competitions_list: 'Yarışmalar Listesi',
    search_competitions: 'Yarışmaları ara...',
    are_you_sure_you_want_to_delete_the_competition:
      'Bu yarışmayı silmek istediğinizden emin misiniz?',
    history: 'Geçmiş',
    export: 'Dışa Aktar',
    search_by_name: 'İsme göre ara...',
    no_historical_data_available_for_the_selected_period:
      'Seçilen dönem için geçmiş veri yok.',
    no_leaderboard_data_available: 'Lider tablosu verisi yok.',
    competitions: 'Yarışmalar',
    leaderboards: 'Lider Tabloları',
    welcome_back: 'Tekrar Hoş Geldiniz',
    track_your_performance_and_see:
      'Performansınızı takip edin ve sıralamanızı görün',
    team_leaderboard: 'Takım Lider Tablosu',
    try_again: 'Tekrar Dene',
    no_competitions_for_search: 'Aranan kriterlere uygun yarışma yok',
    no_competitions_available: 'Yarışma mevcut değil',
    no_competitions_matching_search:
      'Aramanızla eşleşen yarışma bulunamadı. Arama terimlerinizi ayarlayın veya daha sonra tekrar kontrol edin.',
    no_competitions_general:
      'Şu anda hiçbir yarışma ayarlanmamış. Daha sonra tekrar kontrol edin veya yeni yarışma oluşturmak için yöneticinizle iletişime geçin.',
    media_management: 'Medya Yönetimi',
    badgess_set: 'Rozet Seti',
    choose_the_default_visual_style_for_badge:
      'Platform genelinde kullanılacak rozet simgelerinin varsayılan görsel stilini seçin',
    enable_badges: 'Rozetleri Etkinleştir',
    add_badge: 'Rozet Ekle',
    min: 'Min',
    max: 'Maks',
    your_rank: 'Sıralamanız',
    your_points: 'Puanlarınız',
    your_level: 'Seviyeniz',
    rank: 'Sıra #',
    level: 'Seviye',
    progress: 'İlerleme',
    new_folder: 'Yeni Klasör',
    file_upload: 'Dosya Yükle',
    writer: 'Yazar',
    text_documents: 'Metin Belgeleri',
    spreadsheets: 'Tablolar',
    impress: 'Sunum',
    presentations: 'Sunumlar',
    capture_desktop_screen: 'Masaüstü Ekranını Yakala',
    capture_desktop_screens: 'Masaüstü Ekranlarını Yakala',
    your_documents: 'Belgeleriniz',
    manage_your_videos_images_audio_files:
      'İçerik oluşturmak için kullanılan videolarınızı, resimlerinizi, ses dosyalarınızı ve diğer varlıklarınızı yönetin',
    your_organization_documents: 'Organizasyon Belgeleriniz',
    keep_your_organization_creative_assets_organized:
      'Organizasyonunuzun yaratıcı varlıklarını düzenli ve erişilebilir tutun—ekip çalışmasını ve içerik üretimini kolaylaştırın',
    your_public_documents: 'Herkese Açık Belgeleriniz',
    curated_collection_of_media_assets_available:
      'Herkes için kullanılabilir, özenle seçilmiş medya varlıkları koleksiyonu—keşfedin, yeniden kullanın ve yaratın',
    your_download_center_documents: 'İndirme Merkezi Belgeleriniz',
    repository_of_approved_media_assets_for_download:
      'Projelerinizde kullanmak için onaylanmış medya varlıkları deposu',
    search_files_and_folders: 'Dosya ve klasörlerde ara..',
    home: 'Ana Sayfa',
    folders: 'Klasörler',
    folder_name: 'Klasör Adı',
    owner: 'Sahip',
    last_updated: 'Son Güncelleme',
    action: 'İşlem',
    no_folders_found: 'Klasör bulunamadı',
    files: 'Dosyalar',
    enabling_ai: 'AI etkinleştiriliyor...',
    rename: 'Yeniden Adlandır',
    copy: 'Kopyala',
    move: 'Taşı',
    verson_history: 'Sürüm Geçmişi',
    manage_permission: 'İzinleri Yönet',
    generate_audit_report: 'Denetim Raporu Oluştur',
    last_edited: 'Son Düzenleme',
    no_files_found: 'Dosya bulunamadı',
    are_you_sure_you_want_to_make_this_item_public:
      'Bu öğeyi herkese açık yapmak istediğinizden emin misiniz? Bu, genel kütüphanenize kopyalanacaktır.',
    move_to_organization: 'Kuruluşa Taşı',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'Bu öğeyi kuruluş kütüphanenize kopyalamak istediğinizden emin misiniz?',
    are_you_sure_you_want_to_make_this_item_private:
      'Bu öğeyi özel yapmak istediğinizden emin misiniz? Bu, kendi kütüphanenize kopyalanacaktır.',
    date_modified: 'Değiştirilme Tarihi',
    workflow_management: 'İş Akışı Yönetimi',
    configure_editors_approvers_and_viewers_for_this_document:
      'Bu belge için düzenleyicileri, onaylayıcıları ve izleyicileri yapılandırın',
    error_Loading_editor: 'Düzenleyici yüklenirken hata oluştu',
    debug_info: 'Hata Ayıklama Bilgisi',
    loading_editor: 'Düzenleyici yükleniyor...',
    submitted_for_review: 'İnceleme için gönderildi',
    editors: 'Düzenleyiciler',
    no_editors_added_yet:
      'Henüz düzenleyici eklenmedi. Eklemek için "Düzenleyici Ekle"ye tıklayın.',
    add_editor: 'Düzenleyici Ekle',
    approvers: 'Onaylayıcılar',
    no_approvers_added_yet:
      'Henüz onaylayıcı eklenmedi. Eklemek için "Onaylayıcı Ekle"ye tıklayın.',
    add_approvers: 'Onaylayıcı Ekle',
    viewer: 'İzleyici',
    no_viewers_added_yet:
      'Henüz izleyici eklenmedi. Eklemek için "İzleyici Ekle"ye tıklayın.',
    add_viewer: 'İzleyici Ekle',
    are_you_sure_you_want_to_delete_the_selected_items:
      'Seçili öğeleri silmek istediğinizden emin misiniz?'
  },
  v3: {
    reportShareSphere: 'Paylaş Küresi',
    overview: 'Topluluk Anketi Genel Bakış',
    triviaReport: 'ShareSphere Bilgi Yarışması',
    overviewGraph: 'Topluluk Genel Grafik',
    category: 'Kategori',
    phCategory: 'Kategori Seçin',
    podcast: 'Podcast, Müzik ve Hikayeler',
    pastPodcast: 'Geçmiş Podcastler',
    upcomingPodcast: 'Yaklaşan Podcastler',
    podcastLanguageTitle: 'Podcast, Müzik ve Hikaye Dili',
    podcastLanguageCheckbox: 'Podcast dilim için yapay zeka hizmeti kullan',
    howRate: 'Bu podcasti nasıl değerlendirirsiniz?',
    podcastSubmit: 'Gönder',
    podcastGuest: 'Konuk:',
    podcastReview: 'Yorum',
    podcastEpishode: 'Bölüm',
    podcastEnd: 'Podcast Sona Erdi',
    date_podcast: 'Podcast Tarihi',
    skill_not_found: 'Üzgünüz! Beceri yolculuğu bulunamadı',
    coaching: 'Koçluk',
    webinar: 'Web Semineri',
    public_conference: 'Herkese Açık Konferans',
    skill_journey_subtitle:
      'Becerilerinizi seçin ve kimin görebileceğini ve sizinle iletişime geçebileceğini kontrol edin',
    enable_white_label: 'White Label’ı Etkinleştir',
    create_new_event_org: 'Organizasyonunuz için yeni etkinlik oluşturun',
    create_new_event_marketplace: 'Pazar yeri için yeni etkinlik oluşturun',
    create_new_event_both:
      'Organizasyonunuz ve pazar yeri için yeni etkinlik oluşturun',
    event_outline: 'Etkinlik ana hatlarını girin',
    event_obj: 'Etkinlik hedeflerini girin',
    event_description: 'Etkinlik açıklamasını girin',
    create_new_metamaze_org: 'Organizasyonunuz için yeni Metamaze oluşturun',
    create_new_metamaze_marketplace: 'Pazar yeri için yeni Metamaze oluşturun',
    create_new_metamaze_both:
      'Organizasyonunuz ve pazar yeri için yeni Metamaze oluşturun',
    add_key_words: 'Anahtar kelimeler ekleyin',
    press_enter_make_keyword:
      'Anahtar kelime oluşturmak için Enter tuşuna basın',
    disable_skip_quiz: 'Testi Atlamayı Devre Dışı Bırak',
    warning_complete_quiz: 'Devam etmek için lütfen testi tamamlayın',
    signup_email_verification:
      'Doğrulama bağlantısı e-postanıza gönderildi, lütfen tıklayın',
    verifying_registration: 'Kayıt doğrulanıyor...',
    reset_password_linK:
      'Şifre sıfırlama bağlantısı e-postanıza gönderildi, lütfen tıklayın',
    reset_email_error:
      'Bu e-posta ile ilişkili bir hesap bulunamadı, lütfen farklı bir kullanıcı adı deneyin',
    first_name: 'Ad',
    last_name: 'Soyad',
    error_firstName: 'Lütfen adınızı girin',
    error_sharebot_organization: 'Lütfen organizasyon adını girin',
    error_lastName: 'Lütfen soyadınızı girin',
    private_conference: 'Özel Konferans',
    public_conference: 'Herkese Açık Konferans',
    discussion_room: 'Tartışma Odası',
    training_no_courses: 'Henüz herhangi bir kursa katılmadınız',
    training_no_events: 'Henüz herhangi bir etkinliğe katılmadınız',
    allow_sharing_trainer_info:
      'Eğitmen e-postasının pazarda paylaşılmasına izin ver',
    error_username_space: 'Kullanıcı adı boşluk içeremez',
    error_sharebot_organization_space: 'Organizasyon adı boşluk içeremez',
    edit_permission: 'Düzenleme Yetkisi',
    valid_price: 'Fiyat 0’dan büyük olmalı',
    course_price_message:
      '*Bu kurs yalnızca kurum içi kullanım içindir ve pazarda satılamaz',
    valid_edit_price: 'Düzenleme fiyatı, satın alma fiyatından düşük olmalı',
    my_calendar: 'Takvimim',
    error_valid_firstName: 'Geçerli bir ad girin',
    error_valid_organization: 'Geçerli bir organizasyon adı girin',
    error_valid_lastName: 'Geçerli bir soyad girin',
    error_name_spaces: 'Ad boşluk içeremez',
    items: 'Öğeler',
    publish_to_channel: 'Kanalımda Yayınla',
    create_a_channel: 'Kanal Oluştur',
    create_a_trivia: 'Bilgi Yarışması Oluştur',
    create_a_new_channel: 'Yeni Kanal Oluştur',
    add_videos: 'Video Ekle',
    save_and_continue: 'Kaydet ve Devam Et',
    channel: 'Kanal',
    channels: 'Tüm Kanallar',
    view_channel: 'Kanalı Görüntüle',
    edit_channel: 'Kanalı Düzenle',
    delete_channel: 'Kanalı Sil',
    my_video_channels: 'Video Kanallarım',
    training_no_channel: 'Henüz herhangi bir kanala katılmadınız',
    monthly_price_required: 'Aylık fiyat zorunludur',
    yearly_price_required: 'Yıllık fiyat zorunludur',
    one_time_price_required: 'Tek seferlik fiyat zorunludur',
    marketplace_quantity: 'Miktar',
    report_webinar: 'Web Semineri',
    report_coaching: 'Koçluk',
    report_channel: 'Kanal',
    report_public_conference: 'Herkese Açık Konferans',
    report_maze: 'Labirent',
    channel: 'Kanal',
    edit_price: 'Fiyatı Düzenle ($)',
    quantity: 'Miktar',
    payment_type: 'Ödeme Türü',
    total_amount: 'Toplam Tutar ($)',
    net_amount: 'Net Tutar ($)',
    edit_option: 'Seçeneği Düzenle',
    marketplace_price: 'Pazar Fiyatı ($)',
    market_name: 'Ad',
    duration_min: 'Süre (dakika)',
    users_total: 'Kullanıcılar (toplam)',
    sales_total: 'Toplam Satış ($)',
    search_coaching: 'Koçluk Ara',
    search_channel: 'Kanal Ara',
    search_webinar: 'Web Semineri Ara',
    search_maze: 'Labirent Ara',
    search_public_conference: 'Herkese Açık Konferans Ara',
    buyer_type: 'Alıcı Türü',
    quanity: 'Miktar',
    channel_unit_amount: 'Net Tutar ($)',
    channel_updated_at: 'Güncellenme Tarihi',
    month_price: 'Fiyat (Aylık)',
    year_price: 'Fiyat (Yıllık)',
    one_time_price: 'Fiyat (Tek Seferlik)',
    sharebot_organization: 'Yeni organizasyon adınızı girin',
    share_sphere: 'Paylaş Küresi',
    ai_course_title: 'Kurs Başlığı',
    ai_input_course_title: 'Lütfen kurs başlığını girin!',
    learning_objective_label: 'Öğrenme Hedefi',
    learning_objective_message: 'Lütfen öğrenme hedefini girin!',
    standard_question: 'Öğrencilerin uyması gereken bir standart var mı?',
    standard_details_label: 'Standart Detayları',
    standard_details_message: 'Lütfen standart detaylarını girin!',
    estimated_duration_label: 'Tahmini Süre (dakika)',
    estimated_duration_message: 'Lütfen tahmini süreyi girin!',
    min_duration_message: 'Minimum süre 5 dakikadır',
    ai_mins: '25 dakika',
    industry_specific_question: 'Belirli bir sektörle ilgili mi?',
    industry_label: 'Sektör Adı',
    industry_message: 'Lütfen sektör adını girin!',
    ai_course_creation: 'AI ile Kurs Oluşturma',
    course_generated: 'Sharelook tarafından oluşturulan kurs',
    ai: 'AI',
    ai_you: 'Sen',
    ai_prompt_ready: 'İsteğiniz hazır, şimdi kurs taslağı oluşturabilirsiniz',
    ai_unable_respond:
      'Üzgünüz! Şu anda isteğinize yanıt verilemiyor, lütfen daha sonra tekrar deneyin',
    ai_hide_toc: 'İçindekileri Gizle',
    ai_preview_toc: 'İçindekileri Önizle',
    ai_generate_toc_now: 'İçindekileri Şimdi Oluştur',
    ai_creation_course_title: 'Kurs Başlığı:',
    ai_creation_industry_specific: 'Sektöre Özel mi:',
    ai_creation_industry: 'Sektör:',
    ai_creation_standard_needed: 'Standart Gerekli mi:',
    ai_creation_standard_details: 'Standart Detayları:',
    ai_creation_estimated_duration: 'Tahmini Süre (dakika):',
    minutes: 'dakika',
    ai_creation_learning_objective: 'Öğrenme Hedefi:',
    setup_again: 'Yeniden Ayarla',
    ai_creation_confirm_title: 'Yeniden ayarlamak istiyor musunuz?',
    ai_creation_confirm_content:
      'Tüm sohbet ve oluşturulan içerik sıfırlanacaktır',
    ai_toc: 'İçindekiler',
    ai_note_topic: 'Not: Konuları sürükleyip bırakabilirsiniz',
    ai_add_topic: '+ Konu Ekle',
    add_topic: 'Konu Ekle',
    add_lesson: 'Ders Ekle',
    add_new_lesson: 'Yeni Ders Ekle',
    ai_add_lesson: '+ Ders Ekle',
    attention: 'Dikkat',
    before_varifying: 'Doğrulamadan önce',
    ai_save_later: 'Daha Sonra Kaydet',
    ai_download_word_doc: 'Word Belgesi İndir',
    ai_download_course_word_doc: 'Kursu Word belgesi olarak indir',
    ai_create_course_button: 'Kurs Oluştur',
    ai_generate_course_content: 'Kurs İçeriği Oluştur',
    ai_out_of: '/',
    ai_subtopic_failed_content:
      'Bazı alt konular oluşturulamadı, lütfen "Kurs İçeriğini Oluştur" düğmesine tekrar tıklayın',
    ai_edit_topic: 'Konuyu Düzenle',
    ai_edit_lesson_title: 'Ders Başlığını Düzenle',
    ai_save_topic: 'Konuyu Kaydet',
    ai_save: 'Kaydet',
    ai_save_lesson_title: 'Ders Başlığını Kaydet',
    ai_add_new_topic: 'Yeni Konu Ekle',
    ai_download_ref: 'Kaynaklı İndir',
    ai_download_ref_content:
      'Kurs, kaynakları içeren bir Word belgesi olarak indirilecektir',
    ai_download_without_ref: 'Kaynaksız İndir',
    ai_download_two_word: 'İki Word Belgesi İndir:',
    ai_download_two_word_content_one: '- Biri sadece içerik (kaynaklar hariç),',
    ai_download_two_word_content_two: 'diğeri sadece kaynaklar (içerik hariç)',
    ai_manage_content: 'İçeriği Yönet',
    ai_add_content_from_internet: '+ İnternetten İçerik Ekle',
    ai_confirm_start: 'Başlamayı Onayla',
    ai_Verify: 'Doğrula',
    ai_undo_warning:
      'Bu işlem biraz zaman alabilir, lütfen pencereyi kapatmayın. Geri alınamaz.',
    ai_verified_content: 'İçeriği doğruladınız, AI sohbeti artık kullanılamaz',
    ai_want_proceed: 'Devam etmek istediğinizden emin misiniz?',
    upload_simulation: 'Simülasyon Yükle',
    name_simulation: 'Simülasyon Adı',
    selected_simulation_files: 'Seçilen Simülasyon Dosyaları',
    score_between_one_hundred: 'Puan 1 ile 100 arasında olmalıdır',
    are_sure_simulation:
      'Bu simülasyon dosyasını silmek istediğinize emin misiniz?',
    required_simulation: 'Puan gereklidir',
    required_section_file: 'Bölüm dosyası gereklidir',
    simulation: 'Simülasyon',
    simulation_quiz_games: 'Sorular sınav oyunu olmalıdır',
    simulation_alert_des:
      'Tüm sorular tek veya çoktan seçmeli ise oyun eklenebilir',
    alert_info: 'Bilgi',
    ai_number_quiz: 'Soru Sayısı',
    ai_point: 'Puan',
    ai_points: 'Puan',
    val_required: 'Zorunlu',
    games: 'Oyunlar',
    add_simulation: 'Simülasyon Ekle',
    text_tiewer: 'Metin Görüntüleyici',
    back_to_account: 'Hesaba Dön',
    delete_account: 'Hesabı Sil',
    delete_account_title: 'Hesabınızı silmek istediğinize emin misiniz?',
    delete_account_subtitle: 'Hesabınızı buradan silebilirsiniz',
    delete_account_cannot_undo: 'Hesabınız silinecek ve bu işlem geri alınamaz',
    account_org_profile:
      'Tüm hesap, kurs ve organizasyon verileri silinecektir',
    deleting_account_database:
      'Hesap silindikten sonra tüm veriler sistemden kaldırılacaktır',
    account_confirm_delete: 'Hesabınızı silmek istediğinize emin misiniz?',
    action_cannot_be_undone: 'Bu işlem geri alınamaz',
    account_delete_message_success: 'Hesabınız başarıyla silindi',
    message_edit: 'Düzenle',
    message_delete: 'Sil',
    message_reply: 'Yanıtla',
    attached_file: 'Ekli Dosya',
    attach_file: 'Dosya Ekle',
    attach_des: 'Maksimum 25 MB',
    view: 'Görüntüle',
    go_to_marketplace: 'Pazaryerine Git',
    learning_center: 'Öğrenme Merkezi',
    knowledge_center: 'Bilgi Merkezi',
    sharebot: 'ShareBot',
    sharebot_help_message: 'Bugün size nasıl yardımcı olabilirim?',
    my_organization: 'Organizasyonum',
    world_knowledge: 'Dünya Bilgisi',
    welcome_to_sharelook: "Sharelook'a Hoş Geldiniz!",
    sharelook_you_want_go: 'Bugün nereye gitmek istersiniz?',
    shareLook_learning_management_system:
      'Canlı etkinlikler ve kurslar oluşturmak ve katılmak için ShareLook öğrenme yönetim sistemine girin',
    shareLook_powerful_ai_system:
      'PDF belgelerini yükleyin ve ShareLook’un güçlü AI sistemiyle bilgileri hızla çıkarın, kurumsal veya küresel bilgilerden yanıtlar alın',
    edit_now: 'Şimdi Düzenle',
    sharelook_log_out:
      'Sharelook oturumunuz kapatıldı, lütfen tekrar giriş yapın!',
    sorry_error: 'Üzgünüz! Bir hata oluştu',
    login: 'Giriş Yap',
    refresh_page: 'Sayfayı Yenile',
    just_a_moment: 'Bir Saniye',
    enter_lname_fname: 'Devam etmek için lütfen adınızı ve soyadınızı girin',
    procced_to_sharelook: "Sharelook'a Git",
    option_one: 'Seçenek 1',
    option_two: 'Seçenek 2',
    selected_image: 'Seçilen Görsel:',
    add_text: 'Metin Ekle',
    linkdin_is_required: 'LinkedIn gereklidir',
    bio_is_required: 'Biyografi gereklidir',
    save_user_information: 'Kullanıcı Bilgilerini Kaydet',
    select_all: 'Tümünü Seç',
    enable_ai: "AI'yi Etkinleştir",
    load_more: 'Daha Fazla Yükle',
    channel_id: 'Kanal Kimliği',
    send: 'Gönder',
    v4: 'Bilgi',
    subscription: 'Abonelik',
    reset_user_flag: 'Kullanıcı Bayrağını Sıfırla',
    delete_my_accont: 'Hesabımı Sil',
    sharebot_sub_error:
      'Abonelik bilgisi alınırken hata oluştu, lütfen tekrar deneyin!',
    sharebot_no_sub: 'Henüz abone değil',
    sharebot_dont_sub: 'Önceki abonelik bulunamadı',
    sharebot_prev_sub: 'Önceki abonelik',
    sharebot_sub: 'ShareBot Aboneliği',
    sharebot_un_sub: 'ShareBot Aboneliğini İptal Et',
    sharebot_no_available: 'Mevcut veri yok',
    sharebot_start_date: 'Başlangıç Tarihi:',
    sharebot_end_date: 'Bitiş Tarihi:',
    sharebot_sure: 'Emin misiniz?',
    sharebot_do_you_want: 'Şunu yapmak istiyor musunuz:',
    unsubscribe: 'Aboneliği İptal Et',
    unsubscribe_what: 'Aboneliği iptal etmek istiyor musunuz?',
    subscribe: 'Abone Ol',
    subscribe_what: 'Abone olmak istiyor musunuz?',
    subscribe_now: 'Şimdi Abone Ol',
    confirm: 'Onayla',
    sharebot_intel_knowledge_center: 'ShareBot Bilgi Merkezi',
    sharebot_welcome_paragraph:
      'ShareBot Bilgi Merkezine hoş geldiniz. Bu, profesyonellerin hızlı bilgiye erişimini sağlamak için oluşturulmuş yapay zeka asistanınızdır.',
    expired: 'Süresi Dolmuş',
    active: 'Aktif',
    Inactive: 'Aktif Değil',
    yearly_subscription: 'Yıllık Abonelik',
    monthly_subscription: 'Aylık Abonelik',
    no_sharebot_org: 'Herhangi bir ShareBot organizasyonunuz yok',
    sharebot_start_free_trial: 'Ücretsiz Denemeyi Başlat',
    sub_month: 'Aylık Abonelik',
    sub_year: 'Yıllık Abonelik',
    question_per_month: 'Veri Depolama (1TB) ve Aylık 1000 Soru',
    sharebot_para:
      'Devam ederek organizasyonunuzu kalıcı olarak sileceğinizi onaylamış oluyorsunuz. Bu işlem ShareBot tarafından sağlanan tüm değerli içgörülerin kaybolmasına neden olur ve geri alınamaz.',
    cancelled_date: 'İptal Tarihi:',
    live_straming_para:
      'Aylık canlı yayın sınırınızı değiştirmek istiyorsanız lütfen iletişime geçin',
    sharelook_agree: "Sharelook'un",
    terms_condition: 'şartlar ve koşullarını',
    and: 've',
    privacy_policy: 'gizlilik politikasını',
    save_for_later: 'Daha Sonra Kaydet',
    ai: 'Yapay Zeka',
    no_video_yet: 'Henüz Video Seçilmedi!',
    are_you_sure_delete_video: 'Bu videoyu silmek istediğinize emin misiniz?',
    video_des: 'Açıklama',
    video_now: 'Şimdi',
    video_playing: 'Oynatılıyor:',
    video_no: 'Video No.',
    ai_generated_course: 'Yapay Zeka ile Oluşturulmuş Kurs',
    create_course_on_our_own: 'Kendi Kursunuzu Oluşturun',
    ai_Assisted_ourse_reation: 'Yapay Zeka Destekli Kurs Oluşturma',
    pending: 'Beklemede',
    published: 'Yayınlandı',
    intro_course: 'kursunuza eklemek ister misiniz?',
    clone_course: 'Kopyalamak istiyor musunuz',
    browser_audio_not_support: 'Tarayıcınız ses etiketini desteklemiyor.',
    audio_popup_content:
      'Yazdığınız metin üzerine farklı ses stillerini kullanabilirsiniz. Bla bla bla. Lorem Ipsum matbaa ve dizgi endüstrisinin sahte metnidir.',
    close: 'Kapat',
    podcast_rec: 'KAYIT',
    create_podcast: 'Podcast Oluştur',
    add_admin: 'YÖNETİCİ EKLE',
    delete_all: 'Hepsini Sil',
    ai_podcast_audio: 'Yapay Zeka Podcast Sesi',
    language: 'Dil',
    podcast_download_content:
      '*Düzenlemek için AI ses dosyasını indirerek kendi ses dosyanız haline getirin.',
    upload_audio: 'Ses Yükle',
    browser_do_not_support_audio: 'Tarayıcınız ses öğesini desteklemiyor.',
    upload_cover: 'Kapak Yükle',
    upload_ai_creator: 'Yapay Zeka Oluşturucu',
    required_cover_image: 'Kapak görseli gerekli!',
    room_required_name: 'Podcast adı gerekli!',
    add_guest_list: 'Lütfen konuk listesi ekleyin!',
    podcast_add_participants: 'KATILIMCI EKLE',
    topic_required: 'En az bir konu gerekli',
    podcast_description: 'AÇIKLAMA',
    podcast_date: 'TARİH',
    date: 'Tarih',
    podcast_time: 'zaman',
    podcast_to: 'ile',
    podcast_all_day: 'Tüm gün',
    podcast_start_date_time: 'Başlangıç tarihi ve zaman aralığı gereklidir!',
    podcast_id: 'ID',
    selected_user: 'Seçilen Kullanıcıları Davet Et',
    see_more: 'Daha Fazla Göster',
    see_less: 'Daha Az Göster',
    no_review_yet: 'Henüz yorum yok, ilk siz olun.',
    request_to_speak:
      'Kullanıcının konuşma isteğini kabul etmek istiyor musunuz?',
    kick_user: 'Bu kullanıcıyı atmak istiyor musunuz?',
    accept_request: 'İsteği Kabul Et',
    kick: 'AT',
    started: 'BAŞLADI',
    end: 'BİTTİ',
    join_now: 'Şimdi Katıl',
    podcast_end: 'Podcast sona erdi',
    connecting: 'bağlanıyor...',
    knowledge_center_know_today: 'Bugün ne öğrenmek istersiniz?',
    knowledge_center_question: 'Lütfen önce bir soru girin',
    knowledge_center_error: 'Üzgünüz! Bir hata oluştu.',
    knowledge_center_tooltrip:
      "ShareLook'taki kurum kaynaklarından hızlı cevaplar alın, kaynaklara başvurarak önizleme ve pdf indirme seçeneklerine ulaşın.",
    my_organization: 'Organizasyonum',
    world_knowledge: 'Dünya Bilgisi',
    open_file: 'Dosyayı Aç',
    reference: 'Kaynak',
    are_you_cancel: 'İptal etmek istediğinize emin misiniz?',
    are_you_remove_media: 'Bu medyayı silmek istediğinize emin misiniz?',
    terms_agree: 'Bu şartları kabul ediyorum',
    ready: 'Hazır',
    send_email: 'E-POSTA GÖNDER',
    active_users: 'Aktif kullanıcılar',
    sign_up_user: 'Kayıtlı kullanıcılar',
    non_sign_up_user: 'Kayıtsız kullanıcılar',
    organisation: 'Organizasyon',
    usage_report: 'Kullanım Raporu',
    check_email: 'E-postanızı kontrol edin',
    delete_schedule: 'Programı Sil',
    are_you_sure_delete_schedule:
      'Bu programı silmek istediğinizden emin misiniz?',
    add_task: 'Lütfen bir görev girin!',
    coaching_available: 'Koçluk Uygunluğunu İşaretle',
    message_booking_coaching:
      'Bu zaman dilimi bir kullanıcı tarafından koçluk için rezerve edilmiştir.',
    task_day: 'Görev Günü',
    created_task_day: 'Bu gün için bir görev oluşturdunuz.',
    event_day: 'Etkinlik Günü',
    has_booked_coaching: 'Bu gün için bir koçluk randevusu alınmış.',
    active_day: 'Aktif Gün',
    selectable_time_slots:
      'Sağdaki seçilebilir zaman dilimleri bu gün için aktiftir.',
    compare_last_month: 'Geçen ayla karşılaştırıldığında',
    uploading_file: 'Dosyanız yükleniyor',
    attach_file_course: 'bu kursa eklendi.',
    fetch_request: 'İsteğiniz getiriliyor',
    finilize_upload: 'Yükleme tamamlanıyor',
    scorm_scanned: 'Lütfen bekleyin... Yüklenen SCORM zip taranıyor.',
    scan_status: 'Tarama Durumu:',
    scan_completed: 'Tarama Tamamlandı. Dosyanız',
    scan_progress: 'Tarama devam ediyor...',
    check_scorm:
      'SCORM dosya formatınız kontrol ediliyor... Lütfen bekleyin...',
    file_check_success: 'Dosya kontrolü başarılı',
    file_check_progress: 'Dosya kontrolü devam ediyor...',
    scorm_not_upload:
      'Yüklediğiniz dosya SCORM 1.2 standardında değil, lütfen tekrar yükleyin.',
    select_question: 'Cevap Seçenekleri (bir doğru cevap seçin)',
    select_answer: 'Lütfen bir cevap seçin!',
    check_option_one: 'Lütfen birinci seçeneği girin!',
    check_option_two: 'Lütfen ikinci seçeneği girin!',
    check_option_three: 'Lütfen üçüncü seçeneği girin!',
    check_option_four: 'Lütfen dördüncü seçeneği girin!',
    question_image: 'Soru Görseli',
    select_question_image: 'Lütfen bir soru görseli seçin!',
    ans_image: 'Cevap Görseli',
    upload_image_question: 'Cevap Görseli Yükle',
    select_image_answer: 'Lütfen bir cevap görseli seçin!',
    save_question: 'Soruyu Kaydet',
    do_you_leave: 'Çıkmak istediğinizden emin misiniz?',
    loose_all_progress: 'Tüm ilerlemeniz kaybolacak.',
    welcome: 'Hoş geldiniz',
    team_knowledge_quest: 'Takım Bilgi Yarışı',
    your_score: 'Puanınız',
    start_playing: 'Oynamaya Başla',
    share_sphere_complete: 'ShareSphere Tamamlandı',
    final_score: 'Son Puan',
    play_next: 'Sonrakini Oyna',
    you_donot_access_event: 'Bu etkinliğe erişiminiz yok.',
    ai_content_generated: 'Bu konu için içerik oluşturuldu.',
    ai_popup_confirm_content: 'İçerik Oluşturmayı Onayla',
    limit_transcribe_text:
      'Kalan Deşifre Süresi: <0>{{ transcribe_limit }}</0> dakika <1/><2/> <3>. Deşifre limitinizi değiştirmek için lütfen iletişime geçin: </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'Bu etkinliğe erişiminiz yok.',
    ai_course_title_training: 'Liderlik eğitimi kursları',
    ai_course_object: 'Dijital Çağda Liderlikte Yol Almak',
    create_ai_video: 'Yapay Zeka Videosu Oluştur',
    generate: 'OLUŞTUR',
    video_generate_process:
      'Video oluşturma süreci biraz zaman alabilir. Tamamlandığında size e-posta gönderilecektir.',
    stripe_account_connect:
      'Stripe hesabınız etkin değil. Devam etmek için lütfen bağlayın veya etkinleştirin.',
    ai_creator: 'Yapay Zeka Oluşturucu',
    check_video_status: 'Video oluşturma durumu kontrol ediliyor...',
    video_on_queue: 'Video oluşturma işlemi sıraya alındı.',
    video_fail_generation:
      'Üzgünüz, video oluşturma işlemi başarısız oldu. Lütfen başka bir video deneyin.',
    video_currently_generated: 'Bu video şu anda oluşturuluyor.',
    checking_status: 'Durum kontrol ediliyor',
    check_status: 'Durumu Kontrol Et',
    browser_does_not_support_audio: 'Tarayıcınız ses etiketini desteklemiyor',
    existing_edit_scenario:
      'Mevcut senaryoyu düzenlemek mi yoksa yeni bir senaryo oluşturmak mı istiyorsunuz? Yeni bir senaryo oluşturursanız, eski senaryo kaybolacaktır.',
    generate_scenario: 'Senaryo Oluştur',
    layout: 'Yerleşim',
    confirm_change: 'Değişikliği Onayla',
    generated_ai_creation_message:
      'Lütfen dikkat: Sadece yapay zeka tarafından oluşturulan metin öğeleri korunacaktır. Diğer tüm öğeler sayfadan kaldırılacaktır.',
    generate_story: 'Hikaye Oluştur',
    save_original_content: 'Orijinal içeriği kaydet:',
    story_added_specified_position:
      'Hikayenin dersteki konumu. Hikaye, belirlenen konumda bir blok olarak eklenecektir.',
    position_of_story: 'Hikayenin Konumu',
    start_the_lesson: 'Dersin Başlangıcı',
    end_the_lesson: 'Dersin Sonu',
    add_story_pages: 'Hikayeyi Sayfalara Ekle',
    browser_does_not_support: 'Tarayıcınız ses öğesini desteklemiyor.',
    no_video_available: 'Hiçbir video mevcut değil.',
    no_podcast_available: 'Hiçbir podcast mevcut değil.',
    no_item_baskets: 'Sepette ürün yok.',
    ai_course_object: 'Dijital Çağda Liderlikte Yol Almak'
  },
  v2: {
    n_data: 'Veri Yok',
    change: 'Değiştir',
    remove: 'Kaldır',
    auto_background: 'Otomatik Arka Plan',
    create_new_course_org: 'Kuruluşunuz için yeni bir kurs oluşturun.',
    create_new_course_marketplace: 'Pazar yeri için yeni bir kurs oluşturun.',
    create_new_course_both:
      'Hem kuruluşunuz hem de pazar yeri için yeni kurs oluşturun.',
    ok: 'Tamam',
    page_bg: 'Sayfa Arka Planı',
    lesson_cover: 'Ders Kapak Resmi',
    create_skill_journey: 'Yetenek Yolculuğu Oluştur',
    Metamaze: 'Metamaze',
    events: 'Etkinlikler',
    scroms: 'SCORMlar',
    min_score_pass: 'Geçme için Minimum Puan',
    no_scorms_available: 'Mevcut SCORM yok.',
    no_events_available: 'Mevcut etkinlik yok.',
    no_courses_available: 'Mevcut kurs yok.',
    no_courses_baskets: 'Sepette kurs yok.',
    no_mazes_baskets: 'Sepette labirent yok.',
    no_scroms_baskets: 'Sepette SCORM yok.',
    no_events_baskets: 'Sepette etkinlik yok.',
    sorry: 'Üzgünüz!',
    option_1: 'Seçenek 1',
    option_2: 'Seçenek 2',
    enter_number_words: 'Maksimum kelime sayısını girin.',
    summarize: 'Özetle',
    answer: 'Cevap',
    hold_tight_one_minute:
      'Sabırlı olun! Hazırlanıyoruz. Bu işlem bir dakikaya kadar sürebilir.',
    enter_question: 'Sorunuzu girin.',
    enter_relevant_documents: 'İlgili belge sayısını girin.',
    please_input_relevant_documents: 'Lütfen ilgili belge sayısını girin!',
    please_wait_loading_results: 'Lütfen sonuçların yüklenmesini bekleyin...',
    proceed_to_add_voice: 'Sese Ekleme İşlemine Devam Et',
    results: 'Sonuçlar',
    no_result_found_try_asking_questions:
      'Sonuç bulunamadı. Daha fazla soru sormayı deneyin.',
    eg: 'örneğin,',
    what_make_sales_manager: 'Beni satış müdürü yapacak şey nedir?',
    please_select_lang: 'Lütfen herhangi bir dil seçin!',
    search: 'Ara',
    please_copy_desired_content:
      'Lütfen sol kutudan istediğiniz içeriği sağ kutuya kopyalayın.',
    rating_req: 'Puanlama zorunlu bir alandır.',
    review_req: 'Yorum zorunlu bir alandır.',
    rating_review_req: 'Hem puan hem de yorum sağlanmalıdır.',
    how_rate_this: 'Bunu nasıl değerlendirirsiniz?',
    amazing_above_expectations: 'Harika! Beklentilerin üzerinde!',
    certificates: 'Sertifikalar',
    you_no_certificates: 'Şu anda mevcut sertifikanız yok.',
    please_add_review: 'Lütfen puanla birlikte bir yorum ekleyin, teşekkürler!',
    post: 'Gönder',
    rate: 'Puanla',
    avg_rating: 'Ortalama Puan',
    no_review_found: 'Yorum bulunamadı',
    are_sure_to_disale_zoom_integration:
      'Zoom entegrasyonunu devre dışı bırakmak istediğinize emin misiniz?',
    badges: 'Rozetler',
    you_no_badge_available: 'Şu anda mevcut rozetin yok.',
    download_certificate: 'Sertifikayı İndir',
    loading: 'Yükleniyor...',
    no_file_attached: 'Ekli dosya yok',
    you_do_not_have_any_notes: 'Herhangi bir notunuz yok.',
    question: 'Soru',
    score: 'Puan',
    alert_score_message: 'Kişi(ler) puanlarını gönderdi.',
    alert_question_message: 'Şu ana kadar soru eklenmedi.',
    button_submit: 'Gönder',
    button_allScores: 'Tüm puanlar gönderildi.',
    record_wait: 'Kayıt başlıyor. Lütfen bekleyin...',
    buttonSubmit_warning: 'Lütfen gönderim yapmadan önce tüm puanları girin.',
    upload_ar_assets: 'AR Varlıklarını Yükle',
    edit_ar_assets: 'AR Varlıklarını Düzenle',
    edit_maze_assets: 'MetaMaze Varlıklarını Düzenle',
    upload_assets: 'Varlıkları Yükle',
    upload_maze_assets: 'MetaMaze Varlıklarını Yükle',
    trigger_title: 'Tetikleyici Başlığı',
    model_title: 'Model Başlığı',
    trigger_description: 'Tetikleyici Açıklaması',
    model_description: 'Model Açıklaması',
    please_type_target_description: 'Lütfen hedef açıklamayı yazın.',
    please_type_model_description: 'Lütfen model açıklamasını yazın.',
    trigger_image: 'Tetikleyici Görsel*',
    model_image: 'Model Görsel*',
    upload_trigger_image: 'Tetikleyici Görsel Yükle',
    upload_model_image: 'Model Görsel Yükle',
    drag_n_drop: 'Sürükle ve Bırak',
    file_size_should_not_exceed:
      '(Resim Dosyası (JPEG) boyutu 512 KB’yi aşmamalıdır)',
    zip_size_should_not_exceed: '(Zip Dosyası boyutu 60 MB’yi aşmamalıdır)',
    ar_content: 'AR İçeriği*',
    model_content: '3D Model*',
    upload_3d_zip: 'ZIP / Video Yükle',
    upload_3d_maze_zip: 'ZIP Yükle',
    audio_content: 'Ses İçeriği',
    _mp3: '(.mp3)',
    content_attached: 'Zip Eklendi.',
    video_attached: 'Video Eklendi.',
    audio_attached: 'Ses Eklendi.',
    enter_trigger_image_title: 'Tetikleyici görsel başlığını girin.',
    enter_model_title: 'MetaMaze model başlığını girin.',
    ar_preview_image: 'AR Önizleme Görseli',
    upload_preview_image: 'Önizleme Görseli Yükle',
    upload_audio: 'Ses Yükle',
    creating___: 'Oluşturuluyor...',
    updating___: 'Güncelleniyor...',
    create: 'Oluştur',
    update: 'Güncelle',
    ar_assets: '3D Görsel',
    _3d_files_mp4: '(Sıkıştırılmış .obj, .fbx veya .mp4 Video)',
    _3d_files_mp4_ar: '(Sıkıştırılmış .obj, .fbx)',
    maze_3d_files_mp4: '(Sıkıştırılmış .obj, .fbx)',
    _jpg_files: 'Sadece .jpg desteklenir',
    persons_have_submitted_their_scores: 'Kişiler puanlarını gönderdi.',
    no_questions_added_till_now: 'Şu ana kadar soru eklenmedi.',
    submit: 'Gönder',
    all_scores_submitted: 'Tüm puanlar gönderildi.',
    recording_is_starting: 'Kayıt başlıyor. Lütfen bekleyin...',
    please_input_scores_before_submitting:
      'Göndermeden önce lütfen tüm puanları girin.',
    end_for_all: 'Herkes için Bitir',
    full_screen: 'Tam Ekran',
    breakout_room: 'Gruplara Ayrılma Odası',
    send_invitations: 'Davet Gönder',
    add_participants: 'Katılımcı Ekle',
    create_breakout_room: 'Gruplara Ayrılma Odası Oluştur',
    connecting: 'Bağlanıyor...',
    currently_broadcaster_unavailable: 'Şu anda yayıncı müsait değil.',
    how_many_breakout_room_to_create: 'Kaç grup odası oluşturmak istiyorsunuz?',
    create_upto_three_breakout_rooms: '*En fazla 3 grup odası oluşturun',
    allow: 'İzin Ver',
    additional: 'Ekstra',
    attachment: 'Ekler',
    no_description_available: 'Açıklama yok.',
    people: 'KİŞİLER',
    waiting: 'Bekleniyor',
    hand_raising_users: 'El Kaldıran Kullanıcılar',
    invite: 'Davet Et',
    create_room: 'Oda Oluştur',
    create_live_event: 'Canlı Etkinlik Oluştur',
    support_upto_fivethousand_participants:
      'Etkinlik için 5.000’e kadar katılımcı destekler',
    support_upto_ten_participants:
      '10 canlı video katılımcısına kadar destekler',
    support_upto_twohundred_participants:
      'Etkinlik için 200’e kadar katılımcı destekler',
    supprt_upto_five_participants:
      '5 canlı video katılımcısına kadar destekler',
    support_upto_twentyfive_participants:
      'Etkinlik için 25 canlı video katılımcısına kadar destekler',
    two_live_video_participants:
      'Etkinlikte 2 canlı video katılımcısı var (ev sahibi ve katılımcı)',
    you_can_have_upto_five_examinees: 'En fazla 5 sınav katılımcınız olabilir.',
    you_can_have_upto_twentyfive_participants:
      'En fazla 25 katılımcınız olabilir.',
    you_can_have_upto_five_participants: 'En fazla 5 katılımcınız olabilir.',
    you_can_have_upto_ten_participants: 'En fazla 10 katılımcınız olabilir.',
    select_hosts_email: 'Ev Sahibi E-postasını Seçin',
    send_invite_email: 'Davet E-postası Gönder',
    do_not_send_invite_email: 'Davet E-postası Gönderme',
    error: 'Hata',
    max_twentyfive_users_allowed: 'En fazla 25 kullanıcı seçilebilir',
    max_five_users_allowed: 'En fazla 5 kullanıcı seçilebilir',
    max_ten_users_allowed: 'En fazla 10 kullanıcı seçilebilir',
    no_user_found: 'Kullanıcı bulunamadı',
    transcribe_to: 'Şuraya Dönüştür',
    integrate_zoom_to_start_meeting:
      'Zoom toplantısı başlatmak için Zoom’u hesabınıza entegre edin.',
    zoom_is_not_integrated: 'Zoom entegre edilmemiş.',
    delete_poll: 'Anketi Sil',
    add_poll: 'Anket Ekle',
    live_now: 'CANLI!',
    average_rating: 'Ortalama Puan',
    review: 'İnceleme',
    time_spent: 'Harcanan Süre',
    total: 'Toplam',
    mins: 'Dakika',
    no_data: 'Bu sınav için veri yok.',
    total_score: 'Toplam Puan',
    pass_score: 'Geçme Notu',
    point: 'Puan',
    wrong: 'Yanlış',
    response: 'Yanıt',
    submitted: 'Gönderildi',
    average: 'Ortalama',
    total_play: 'Toplam Oynatma',
    view_graph: 'Grafiği Görüntüle',
    time_spent_mins: 'Harcanan Süre (Dakika)',
    play: 'Oynat',
    ideal_path: 'İdeal Yol',
    user_incorrect_path: 'Kullanıcının Yanlış Yolu',
    ideal_path_taken: 'Kullanıcının İzlediği İdeal Yol',
    scenario: 'Senaryo',
    option: 'Seçenek',
    spend: 'Harcanan',
    average_spending_time: 'Ortalama Harcanan Süre',
    activity_overview: 'Aktivite Genel Bakışı',
    live_event: 'Canlı Etkinlik',
    live_assessment: 'Canlı Değerlendirme',
    report_download: 'Rapor İndir',
    all_workshops: 'Tüm Atölyeler',
    overview_average_activity: 'Genel Ortalama Aktivite',
    overview_workshop_graph: 'Atölye Genel Grafik',
    mazes: 'Labirentler',
    correct_feedback: 'Doğru Geri Bildirim',
    incorrect_feedback: 'Yanlış Geri Bildirim',
    checkin_checkout: 'Giriş - Çıkış',
    minutes: 'Dakika',
    incorrect_path: 'Yanlış Yol',
    answer_not_available: 'Cevap Mevcut Değil',
    views: 'Görüntüleme',
    item: 'Öğe',
    questions: 'Sorular',
    total_points: 'Toplam Puanlar',
    total_attempts: 'Toplam Denemeler',
    created_date: 'Oluşturulma Tarihi',
    host_name: 'Ev Sahibi Adı',
    host_section: 'Ev Sahibi Bölümü',
    choose_products: 'Ürünleri Seç',
    add_to_basket: 'Sepete Ekle',
    basket: 'Sepet',
    times: 'Keş',
    scorms: 'SCORMlar',
    skill_journey_overview: 'Yetenek Yolculuğu Genel Bakışı',
    how_to_use: 'Nasıl Kullanılır',
    live_broadcast_description:
      'CANLI VİDEOYU KULLANIMI KOLAY BİR KURS OLUŞTURUCUYA ENTEGRE ETTİK',
    live_broadcast_subdescription:
      'ShareLook’un patentli canlı yayın sistemi ile etkileşim yaratabilir, öğrenmeyi otomatikleştirebilir ve bilgi paylaşımını maksimize edebilirsiniz.',
    disclaimer: `Yetenek yolculuğumun:
  - Üçüncü tarafların haklarını ihlal etmeyeceğini,
  - Aşağıdaki içerikleri barındırmayacağını garanti ederim:
    - hakaret, müstehcen, kaba, pornografik, şiddet içeren, kötü niyetli, aşağılayıcı, tehditkar veya ayrımcı içerikler, hatta yıldız işaretleriyle gizlenmiş olsa bile,
  - Başkalarına yönelik kişisel saldırılar içermeyeceğini,
  - Başkalarının, kamu kişiliklerinin veya ünlülerin taklit edilmesini içermeyeceğini,
  - Herhangi bir bireyin rızası olmadan herhangi bir kayıt veya kişisel bilgiyi içermeyeceğini ve dünya üzerindeki herhangi bir veri koruma düzenlemesini ihlal etmeyeceğini,
  - Herhangi bir ticari teklif veya “spam” içermeyeceğini`,
    price: 'Fiyat',
    video_link: 'Video Bağlantısı',
    category: 'Kategori',
    objectives: 'Amaçlar',
    marketplace_description: 'Pazar Yeri Açıklaması',

    live_discussion: 'CANLI TARTIŞMA',
    poll: 'ANKET',
    hide_grid: 'Gridi Gizle',
    show_grid: 'Gridi Göster',
    stop_screen_share: 'Ekran Paylaşımını Durdur',
    screen_share: 'Ekran Paylaşımı',
    mute: 'Sessize Al',
    unmute: 'Sessizliği Kaldır',
    raise_hand: 'El Kaldır',
    waiting__: 'Bekleniyor...',
    audio_active: 'Ses Aktif'
  },
  general: {
    save: 'içeriği kaydet',
    autosaved: 'otomatik kaydedildi',
    back_to: 'geri dön',
    by: 'tarafından',
    chat: 'sohbet',
    completed: 'Tamamlandı',
    canceled: 'İptal Edildi',
    component: 'Bileşen',
    confirm: 'Onayla',
    course: 'Kurs',
    skill: 'Beceri Yolculuğu',
    maze: 'MetaLabirent',
    channel: 'Kanal',
    podcast: 'Podcast',

    date: 'Tarih',
    details: 'Detaylar',
    empty: 'Veri yok',
    enrolled: 'Kaydedildi',
    free: 'Ücretsiz',
    graph: 'Grafik',
    loading: 'Yükleniyor...',
    lesson: 'ders',
    lessons: 'dersler',
    live_assessment: 'Canlı değerlendirme',
    live_event: 'Canlı etkinlik',
    no: 'Hayır',
    of: 'ın',
    or: 'veya',
    organization: 'organizasyon',
    page: 'Sayfa',
    pages: 'Sayfalar',
    personal: 'Kişisel',
    poll: 'Anket',
    rating: 'Rating',
    reset: 'Sıfırla',
    signin: 'Oturum Aç',
    signup: 'Kayıt ol',
    soon: 'Yakında',
    type: 'Tür',
    uploading: 'Yükleniyor...',
    yes: 'Evet',
    something_went_wrong: 'Bir şeyler ters gitti!',
    view_all: 'Tümünü görüntüle',
    upload_successful: 'Yükleme Başarılı',
    upload_successful_message:
      'Excel dökümanlarınız başarılı bir şekilde yüklendi ve şu anda işleniyor. Bu biraz sürebilir.',
    check_email_upload_successful:
      'Lütfen<0>emailinizi kontrol edin</0> ve yüklenen kullanıcı listesinin <1>raporuna</1> göz atın.',
    is_private: 'Gizli'
  },

  account: {
    title: 'Hesap',
    subtitle: 'Ayarlarınızı ve hesap bilgilerinizi yönetin.',
    saved: 'Hesap başarılı bir şekilde değiştirildi'
  },

  assessments: {
    title: 'Değerlendirmeler',
    subtitle: 'Bir değerlendirme oluştur',
    finished: 'Değerlendirme bitti',
    countdown: 'Canlı değerlendirme birazdan yayında olacak',
    create: 'Değerlendirme Oluştur',
    list_title: 'Değerlendirmeleriniz',
    delete_warning: 'Bu öğeyi silmek istediğinizden emin misiniz?',
    details_title: 'Değerlendirme Detaylarını Ekle',
    details_subtitle:
      'Değerlendirmenize isim verip hedef kitlenize ne öğrenmelerini beklediğinizi söyleyin.',
    disclaimer: `Kayıtlı Değerlendirme aşağıdakileri yapmayacağını garanti ediyorum:
    - herhangi bir üçüncü tarafın haklarını ihlal etmeyecek
    - herhangi bir yasadışı eylem barındırmayacak, gurur zedeleyici, müstehcen, uygunsuz, açık saçık, pornografik, şiddet içeren, küfürlü, aşağılayıcı, tehditkâr, ayrımcı içerikleri veya yıldız işareti ile gizlenmiş olsa dahi içermeyecek
    - diğer kişiler üzerine kişisel saldırıları barındırmayacak
    - diğer katılımcıların, halka mal olmuş kişilerin veya ünlülerin herhangi bir taklidini içermeyecek
    - kişinin rızası olmadan o kişiyle ilgili kayıtlar veya kişisel bilgiler barındırılmayacak ve dünyanın herhangi bir yerindeki verilerin korunması düzenlemeleri ihlal etmeyecek
    - herhangi bir ticari talebi veya “spam” şeklini barındırmayacak`
  },

  buildersettings: {
    title: 'Yayınlama Ayarları',
    subtitle:
      'Ayarları etkinliğinize ekleyerek etkinliğinizi görüntüleyebilir veya etkileşime geçebilirsiniz'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'Ekle',
    add_page: 'Sayfa ekle',
    add_lesson: 'Ders ekle',
    add_answer: 'Yeni cevap ekle',
    add_group: 'Grup Ekle',
    add_organization: 'Organizasyon Ekle',
    add_question: 'Soru ekle',
    add_quiz: 'Test Ekle',
    add_users: 'Kullanıcı Ekle',
    back: 'Geri',
    back_to_course: 'Kurs Genel Bakışına Geri Dön',
    back_to_lesson: 'Ders genel bakışına geri dön',
    back_to_media: 'Medya Kütüphanesine Geri Dön',
    back_to_details: 'Detaylara geri dön',
    cancel: 'İptal Et',
    clear: 'Temizle',
    close: 'Kapat',
    clone: 'Çoğalt',
    close_lesson: 'Dersi Çoğalt',
    clone_course: 'Kursu Çoğalt',
    confirm: 'Onayla',
    create: 'Oluştur',
    download: 'İndir',
    download_mass_user_tamplate: 'Şablon İndir',
    add_mass_users: 'Toplu Biçimde Kullanıcı Ekle',
    upload_excel_list: 'Excel Listesi Yükle',
    delete: 'Medyayı Sil',
    edit: 'Düzenle',
    edit_course: 'Kursu Düzenle',
    enroll: 'Kaydol',
    finish: 'Bitir',
    upload_image: 'Resim yükle',
    upload_image_video: 'Resim veya video yükle',
    select_media_library: 'Medya kütüphanesi seç',
    make_public: 'Halka açık yap',
    make_private: 'Özel yap',
    make_org: 'Organizasyon yap',
    media: 'Medya Kütüphanesi',
    my_theme: 'Temam',
    next: 'İlerle',
    next_lesson: 'Sonraki Ders',
    next_step: 'Sonraki adım',
    previous_step: 'Önceki adım',
    publish: 'Yayınla',
    publish_assessment: 'Değerlendirmeni yayınla',
    publish_course: 'Kursunu yayınla',
    publish_event: 'Etkinliğini yayınla',
    reset: 'Sıfırla',
    reset_elements: 'Öğeleri sıfırla',
    save: 'Kaydet',
    creating: 'Oluşturuluyor...',
    updating: 'Güncelleniyor...',
    saved: 'Kaydedildi',
    save_for_later: 'Sonrası için kaydet',
    save_settings: 'Ayarları kaydet',
    select_files: 'Dosyaları seç',
    select_theme: 'Tema seç',
    start_lesson: 'Derse Başla',
    update: 'Güncelle',
    upload: 'Yükle',
    upload_audio: 'Ses Dosyası Yükle',
    upload_photo: 'Bir profil fotoğrafı yükle',
    upload_video: 'Video Yükle',
    enrolled: 'Kaydedildi',
    unenroll: 'Kayıt silindi',
    from_library: 'Medya Kütüphanesi',
    remove: 'Kaldır',
    removed: 'Kaldırıldı',
    start_broadcast: 'Yayınlamaya Başla',
    end_broadcast: 'Yayını Sonlandır',
    camera: 'Kamera',
    screen: 'Ekran',
    screen_with_camera: 'Kamerayla Ekran'
  },

  card: {
    quick_add: 'Hızlı ekle',
    add: 'Ekle',
    clone: 'Çoğalt',
    completed: 'dersler tamamlandı'
  },

  course: {
    upcoming_course: 'Yaklaşan Kurslar',
    unPublishEvent: 'Etkinliği Yayımdan Kaldır',
    unPublishAssessment: 'Değerlendirmeyi Yayımdan Kaldır',
    pastCourse: 'Alıştırma Kursu',
    upcoming: 'Yaklaşan Canlı etkinlik',
    pastEvent: 'Geçmiş Canlı Etkinlik',
    pastAssessment: 'Geçmiş Canlı Değerlendirme',
    upcomingAssessment: 'Yaklaşan Canlı Değerlendirme',
    created: 'Tarih Oluşturuldu:',
    assignees: 'vekiller',
    organisations:
      ' {{ organizasyonlar}} Organizasyonlar, <2> {{ kullanıcılar }} kullanıcılar</2>',
    event_date: 'Canlı etkinlik tarihi <1> {{ tarih }} </1>',
    delete_warning: 'Bunu silmek istediğinizden emin misiniz',
    clonning_no_lesson:
      'Lütfen bu kursu çoğaltmak için en az bir ders ekleyin.',
    clone_warning: 'Bunu çoğaltmak istediğinizden emin misiniz',
    clone_success: 'çoğaltma sürecinde',
    disclaimer: `Kursumun aşağıdakilere sebep olmayacağını garanti ederim:
    - herhangi bir üçüncü tarafın haklarını ihlal etmeyecek
    - herhangi bir yasadışı eylem barındırmayacak, gurur zedeleyici, müstehcen, uygunsuz, açık saçık, pornografik, şiddet içeren, küfürlü, aşağılayıcı, tehditkâr, ayrımcı içerikleri veya yıldız işareti ile gizlenmiş olsa dahi içermeyecek
    - diğer kişiler üzerine kişisel saldırıları barındırmayacak
    - diğer katılımcıların, halka mal olmuş kişilerin veya ünlülerin herhangi bir taklidini içermeyecek
    - kişinin rızası olmadan o kişiyle ilgili kayıtlar veya kişisel bilgiler barındırılmayacak ve dünyanın herhangi bir yerindeki verilerin korunması düzenlemeleri ihlal
    - herhangi bir ticari talebi veya “spam” şeklini barındırmayacak`
  },

  coursecreate: {
    dropzone_text: 'Medya Ekle',
    sidebar_text: '<1/> sizin <3/> dersleriniz için bir tema seçin',
    delete_warning: 'Silmek istediğinizden emin misiniz?'
  },

  coursepage: {
    quizview_loading: 'Cevaplar kontrol ediliyor. Lütfen bekleyiniz...',
    quizview_answer: 'Cevabınız'
  },

  coursequiz: {
    title: 'Tüm derslerdeki Quizler'
  },

  dashboard: {
    tooltip_title: 'Bu videoyu bir daha gösterme',
    page_title: 'Kurslarınızın İstatistikleri',
    page_subtitle: 'Oluşturduğunuz kursların durumu',
    profile_add_info:
      'Profilinizi tamamlamak için <1>{{tamamlanmamışMetin}}</1> ekleyin.',
    profile_build:
      'Profilinizi <1>burada</1> oluşturun, let us know your interests and skills.',
    profile_title: 'Profil Gücü',
    more_details: 'Daha fazla detay'
  },

  errors: {
    answer: 'Lütfen cevap girin',
    answer_correct: 'Doğru cevabı seçin',
    code: 'Lütfen kodunuzu girin',
    criterion: 'Lütfen kriter girin',
    duration: 'Süre gerekli',
    element: 'Lütfen öğe girin',
    email: 'Lütfen email adresinizi girin',
    email_invalid: 'Girilen email geçersiz',
    feedback_correct: 'Lütfen geri bildirimi doğru girin',
    feedback_incorrect: 'Lütfen yanlış geri bildirimi düzeltin',
    host: 'Lütfen etkinlik sahibini girin',
    host_assessment: 'Lütfen değerlendirme sahibini girin',
    image: 'Lütfen bir resim seçin',
    location: 'Lütfen konumunuzu girin',
    live_location: 'Lütfen bir yayın konumu seçin',
    limit: 'Lütfen canlı yayında geçen dakikaları girin',
    min_3char: 'minimum 3 karakter',
    number: 'lütfen pozitif sayı girin.',
    host_email_require: `Oturum sahibinin email adresi gerekli.`,
    attendee_email_require: `Katılımcının email adresi gerekli.`,
    name: 'Lütfen isminizi girin',
    not_found_course: 'Kurs bulunamadı',
    not_found_event: 'Etkinlik bulunamadı',
    not_found_assessment: 'Değerlendirme bulunamadı',
    password: 'Lütfen şifrenizi girin',
    password_digit: 'En az bir rakam olmalı',
    password_short: 'Şifre çok kısa, en az 10 karakter',
    password_special: 'En az bir özel karakter',
    password_uppercase: 'En az bir büyük harfli karakter',
    password_lowercase: 'En az bir küçük harfli karakter',
    phone: 'Lütfen telefon numaranızı girin',
    phone_invalid: 'Geçersiz telefon numarası',
    position: 'Lütfen pozisyonunuzu girin',
    question: 'Lütfen soru girin',
    start_date: 'Başlangıç Tarihi & Saati gerekli',
    tag: 'Lütfen bir etiket seçin',
    topics: 'Lütfen en az bir konu seçin.',
    live_topics: 'Lütfen konu ekleyin',
    title: 'Lütfen başlık ekleyin',
    title_assessment: 'Lütfen değerlendirme başlığını girin',
    title_course: 'Lütfen kurs başlığını girin',
    title_empty: 'Başlık boş kalamaz',
    title_event: 'Lütfen etkinlik başlığı girin',
    title_lesson: 'Lütfen ders başlığı girin',
    title_quiz: 'Lütfen quiz ismi girin',
    username: 'Lütfen kullanıcı adı girin',
    upload_error: 'Hata - Dosya uyumlu değil!',
    upload_more_than_10:
      'Bir defada sadece maksimum 10 dosya yükleyebilirsiniz.',
    topics_max: 'Lütfen maksimum 3 konu ekleyin.',
    upload_excel: 'Lütfen doğru dosyayı yüklediğinizden emin olun.',
    title_excel: 'Şablon yüklerken hata:',
    file_size_exceed: 'Dosya boyutu fazla büyük',
    subtitle_excel:
      'Lütfen size sağlanan şablonu kullandığınızdan ve sütunların doğru bir şekilde doldurulduğundan emin olun.',
    select_broadcast_option:
      'Lütfen bu etkinliği yayımlayacak bir seçenek seçin',
    multi_hosts_number_error:
      'Sunucuların sayısı bu etkinlik için belirlenenden fazla olamaz',
    conference_people_number_error: `Katılımcıların sayısı bu etkinlik için belirlenenden fazla olamaz.`,
    select_max_host: 'Bu etkinlik için en az 1 sunucu seçin.',
    select_max_conference: 'Bu etkinlik için en az 1 katılımcı seçin.',
    stream_stop_error: 'Yayın beklenmedik bir şekilde durdu!',
    unsecure_context:
      'Önemli Hata: Tarayıcı güvenli olmayan bir içerik yüzünden kamera ve mikrofona erişemiyor. Lütfen SSL kurup https aracılığıyla erişim sağlayın',
    ws_not_supported: 'Önemli Hata: WebSocket bu tarayıcıda desteklenmiyor'
  },

  events: {
    title: 'Canlı Etkinlik Detayları Ekle',
    change_host: 'Oturum Sahibini Değiştir',
    finished: 'Etkinlik sona erdi',
    countdown: 'Canlı etkinlik yayında olacak ',
    subtitle:
      'Canlı etkinliğinize isim verin ve hedef kitlenin ne öğrenmeyi beklemeleri gerektiğini belirtin.',
    poll_disabled: 'Bu etkinlikte anket mevcut değil',
    disclaimer: `Kayıtlı etkinliğimin aşağıdakileri yapmayacağını garanti ediyorum:
    - herhangi bir üçüncü tarafın haklarını ihlal etmeyecek
  - herhangi bir yasadışı eylem barındırmayacak, gurur zedeleyici, müstehcen, uygunsuz, açık saçık, pornografik, şiddet içeren, küfürlü, aşağılayıcı, tehditkâr, ayrımcı içerikleri veya yıldız işareti ile gizlenmiş olsa dahi içermeyecek
  - diğer kişiler üzerine kişisel saldırıları barındırmayacak
  - diğer katılımcıların, halka mal olmuş kişilerin veya ünlülerin herhangi bir taklidini içermeyecek
  - kişinin rızası olmadan o kişiyle ilgili kayıtlar veya kişisel bilgiler barındırılmayacak ve dünyanın herhangi bir yerindeki verilerin korunması düzenlemeleri ihlal etmeyecek
  - herhangi bir ticari talebi veya “spam” şeklini barındırmayacak'`,
    prompt_message:
      'Bu sayfayı terk etmek etkinliğe son verecek. Bu sayfayı terk etmek istediğinize emin misiniz?',
    duration_exceed_message:
      'Yayın süreniz sınırı aşıyor, uygulama yayınlamayı bırakacak.',
    before_schedule_message:
      'Ayarlanmış etkinlik saatinden önce yayını başlatmak üzeresiniz. Lütfen yayını durdurmanın etkinliğe son vereceğini unutmayın.',
    browser_unsupportive_message:
      'Tarayıcınız ekran paylaşımını desteklemiyor. Desteklenen tarayıcıları bu linkte bulabilirsiniz',
    cancel_switch_host_message:
      'Oturum sahibi mevcut değil. Etkinlik siz tarafınca devam ettirilecek.',
    coaching_prompt_message: 'Etkinlik bitene kadar bu sayfayı terk etmeyiniz.',
    event_modal_warn: 'Bu etkinliği terk etmek mi istiyorsunuz?',
    confirm_message: 'Tamam’a tıklarsanız etkinliğiniz sona erecek.',
    screen_share_denied: 'Ekranınızı paylaşmayı reddettiniz',
    media_not_found:
      'Cihazınızda kamera veya mikrofon bulunmuyor veya çalıştırılmasına izin verilmiyor.',
    media_not_access:
      'Kamera veya mikrofon başka bir uygulama tarafından kullanılıyor ki bu da cihazların görünmesine izin vermiyor',
    constraint_error:
      'Video ve ses kısıtlamalarına uyan bir cihaz bulunamadı . Video ve ses kısıtlamalarını değiştirebilirsiniz',
    media_access_denied: 'Kamera ve mikrofona erişim izniniz bulunmamakta.'
  },

  filters: {
    days7: 'Son 7 gün',
    days15: 'Son 15 gün',
    days30: 'Son 30 gün',
    days365: 'Son 365 gün',
    date: 'Tarih oluşturuldu',
    relevance: 'İlgi Düzeyi',
    popularity: 'Popülarite',
    name: 'İsim',
    group: 'Grup',
    Newest_to_Oldest: 'Yeniden Eskiye',
    Oldest_to_Newest: 'Eskiden Yeniye',
    A_Z: 'A’dan Z’ye',
    Z_A: 'Z’den A’ya'
  },

  helpers: {
    password:
      'Hesabınızın güvenliğinden emin olmak için sizden şifrenizde kullanmanız için en az bir küçük harf ve rakam istiyoruz. Ayrıca şifreniz minimum 10 karakter içermelidir.',
    phone:
      'Lütfen telefon numarasının başına ülke kodunu da ekleyin, örneğin: +65',
    username:
      'Kullanıcı adınız kamuya ait bilgi olarak değerlendirilir ve gerektiğinde diğer kullanıcılar ile paylaşılır. Bu yüzden kullanıcı adınızda kişisel bilgilerinizi kullanmamanızı tavsiye ederiz',
    public_description_normal:
      'Size ait <0><0/></0> kaydedildi and varsayılan durumu Gizli olarak belirtildi. Bu da bu içeriği sadece siz görebilirsiniz demektir. Bu içeriği yayınlamak için aşağıdaki seçeneklerden birini seçebilirsiniz. Kursunuzu Halka Açık şekilde yayınlayarak platformda bulunan tüm kullanıcılara mevcut hale getiriyorsunuz. Özel Kullanıcı seçeneği kurslarınızı diğer Özel Kullanıcılarla Sharelook hesaplarıyla ilişkilendirilmiş email adreslerini kullanarak paylaşabilmenizi sağlayacak.',
    public_description_admin:
      'Bu <0><0/></0> kaydedildi ve varsayılan durumu Gizli olarak ayarlandı. Bu da sadece sizin (ve içerik üreticisinin) bu içeriği görebileceği anlamına gelir. Bu içeriği yayınlamak için aşağıdaki seçeneklerden birini seçebilirsiniz. Kursunuzu Halka Açık şekilde yayınlayarak organizasyonunuza dışarıdan dahil olanlar da dahil olmak üzere platformdaki tüm kullanıcıların erişimine açık hale getiriyorsunuz. Organizasyona yönelik yayınlamak demek organizasyon içindeki tüm kullanıcılar bunu görebilecek demektir. 1 veya daha fazla grup için de yayınlayabilirsiniz ki bu da sadece o gruplar içerisindekilerin görebileceği anlamına gelir.  Son olarak, Sharelook hesaplarını ve email adreslerini kullanarak organizasyonunuzun içinden ve dışından özel kullanıcılara da yayın yapabilme seçeneğine sahipsiniz.'
  },

  labels: {
    add: 'Ekle',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'Cevap türü',
    answers: 'Cevaplar',
    back_to_quiz: 'Quiz listesine geri dön',
    back_to_question: 'Soru listesine geri dön',
    chat: 'Sohbet',
    chat_available: 'Bu etkinlikte sohbet mevcut değil',
    chat_report: 'Sohbet Raporu',
    choice_single: 'Tek seçenek',
    choice_multiple: 'Çoktan seçmeli',
    choice_free: '"Serbest" seçim',
    choice_sorting: '"Sınıflandırma" seçenekli',
    choice_matrix: '"Matris Sınıflandırma" seçenekli',
    clone_lesson_permission: 'Çoğaltma izni',
    code: 'Kod',
    correct: 'Doğru',
    created: 'Tarih oluşturuldu',
    clone_modal: 'Kursu çoğalt',
    cloning_course: 'Kurs çoğaltılıyor...',
    cloning: 'Çoğaltılıyor...',
    cloning_course_desc: 'Bu işlem biraz sürebilir. Lütfen biraz sabırlı olun',
    cloning_success: 'Kurs "<0/>" başarılı bir şekilde çoğaltıldı!',
    description: 'Tanım',
    disclaimer: 'Feragat',
    drop_file: 'Dosyayı buraya bırakın...',
    duration: 'Süre',
    edit: 'Düzenle',
    email: 'Email',
    event: 'Etkinlik',
    event_all: 'Tüm Etkinlikleri',
    event_date: 'Canlı Etkinlik Yerel Tarih/Saat',
    event_this: 'Bu Etkinlik',
    expire: 'Geçerliliği sona eriyor',
    expiry_date: 'Son geçerlilik tarihi',
    forgot: 'Şifreyi mi unuttunuz?',
    group: 'Grup',
    groups_list: 'Grup Listesi',
    host: 'Oturum Sahibi',
    id_annotation: 'Dipnot id',
    id_quiz: 'Quiz id',
    incorrect: 'Yanlış',
    interests: 'İlgi alanları',
    invited: 'Davet edildi',
    live_chat: 'Canlı Tartışma',
    live_stream_limit: 'Canlı yayında geçen dakikalar',
    contact_text:
      'Aylık canlı yayın süre limitinizi değiştirmek için lütfen bizimle irtibat kurun',
    contact_admin:
      '<0>Aylık canlı yayın süre limitinizi değiştirmek istiyorsanız lütfen bizimle bu adres üzerinden irtibat kurun</0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'Canlı Yayın Kalan Dakika: <0>{{ sınır }}</0> dakikalar <1/><2/> <3>Aylık canlı yayın süre limitinizi değiştirmek için lütfen bizimle bu adresten irtibat kurun</3> <4>admin@sharelook.com</4>',
    location: 'Konum',
    lessons: 'Dersler',
    location_broadcast: 'Oturum Sahibi Sunucu Konumu',
    location_broadcast_subtitle:
      'Görüntü ses gecikmesini azaltmak için yayıncı oturum sahibinin konumuna en yakın konumu ekleyin',
    media_manager: 'Medya Yöneticisi',
    minutes: 'Dakika',
    name: 'İsim',
    online_quiz: 'Çevrimiçi Quiz',
    organiser: 'Yazar',
    organization: 'organizasyon',
    overall_emotion: 'Genel Tecrübe:',
    organizations_list: 'Organizasyonların Listesi',
    password: 'Şifre',
    participants: 'Katılımcılar',
    picture: 'Resim (16:9)',
    phone: 'Telefon',
    photo: 'Fotoğraf',
    poll: 'Anket',
    position: 'Pozisyon',
    processing: 'İşleniyor',
    privacy_settings: 'Gizlilik Ayarları',
    question: 'Soru',
    quiz_create: 'Yeni Quiz Oluştur',
    quiz_name: 'Quiz İsmi',
    quiz_update: 'Quizi güncelle',
    select_organization: 'Bir organizasyon seçin',
    settings: 'Ayarlar',
    show: 'Göster',
    show_graph: 'Grafik sonuçlarını göster',
    signin: 'Oturum Aç',
    signup: 'Kayıt ol',
    sort_by: 'Sırala',
    start_date: 'Başlangıç tarihi',
    tags: 'Etiketler',
    terms: 'Bu <1>hüküm ve koşullara</1> katılıyorum.',
    title: 'Başlık',
    topics: 'Konular',
    topic: 'Konu',
    total_comments: 'Toplam Yorumlar',
    username: 'Kullanıcı adı',
    users_list: 'Kullanıcı Listesi',
    users_emails: 'Özel kullanıcı emailleri gir',
    description_specifiction_email:
      'Lütfen birden çok özel kullanıcı ile paylaşmak için her satıra 1 email adresi girin.',
    message_specific_email: 'Lütfen özel kullanıcının emailini girin.',
    viewers: 'Görüntüleyiciler',
    edit_course: 'Düzenle',
    edit_assessment: 'Düzenle',
    edit_event: 'Düzenle',
    delete_course: 'Sil',
    delete_event: 'Sil',
    delete_assessment: 'Sil',
    view_course: 'Görüntüle',
    view_event: 'Görüntüle',
    view_assessment: 'Görüntüle',
    date_event: 'Canlı etkinlik tarihi',
    date_assessment: 'Canlı değerlendirme tarihi',
    clone_of: 'Çoğalt',
    clone_course:
      'Ctüm dersleri ve sayfaları içermek üzere bu kursun orijinalinden bağımsız bir şekilde değiştirebileceğiniz bir klonunu oluşturun.',
    make: 'Yap',
    available_to: 'her Sharelook kullanıcısının erişimindedir',
    uploaded_by: 'Yükleyen kişi: ',
    course: 'Kurs',
    assessment: 'Değerlendirme',
    user_not_exist:
      'Böyle bir kullanıcı bulunmuyor, davet göndermek ister misiniz?',
    check_user: 'Tebliğ',
    user_not_exist_in_org:
      'Bu organizasyonda böyle bir kullanıcı bulunmuyor, davet göndermek ister misiniz?',
    title_modal_stream: 'Organizasyon Canlı yayın Sınırını Değiştir',
    des_warning_stream: 'Değiştirmek üzeresiniz',
    monthly_stream: 'aylık canlı yayın limiti:',
    min_per_month: 'dakika/ay',
    broadcast_label: 'Yapmak istiyorum:',
    hosts_emails: `Özel oturum sahibinin emailini girin`,
    attendee_emails: `Özel katılımcının emailini girin`,
    description_host_specifiction_email:
      'Lütfen her satıra 1 email adresi girin.',
    presenter_label: 'Sunucu',
    presenter_label_conference: 'Kişi Sayısı',
    event_privacy: 'Konferans Modu'
  },

  broadcastOptions: {
    stream_from_phone: 'Telefonumla Canlı Yayın',
    other_webrtc: 'Pc’mden Web Semineri',
    multihost: 'Pc’mden Çoklu Web Semineri',
    peer2peer: 'Koçluk Oturumu',
    conference: 'Canlı Konferans'
  },

  lessoncreate: {
    title: 'Ders detaylarını Ekle',
    subtitle:
      'Değerlendirmenize isim verip hedef kitlenize ne öğrenmelerini beklediğinizi söyleyin.',
    input_label_title: 'Ders başlığı',
    input_label_topics: 'Ders konuları',
    input_label_description: 'Ders tanımı',
    delete_warning: 'Bu sayfayı silmek istediğinizden emin misiniz?'
  },

  lessonoverview: {
    title: 'Ders Ekle',
    subtitle: 'Var olan bir ders ekle veya yeni bir tane oluştur',
    new_lesson: 'yeni bir ders oluştur',
    new_lesson_sub: 'En baştan yeni bir ders oluştur!',
    existing_lesson: 'Var olan bir ders seç',
    existing_lesson_sub:
      'Var olan bir derse bağlan; bu ders için yapılan değişiklikler diğer kurslardaki aynı dersi de etkileyecek.',
    clone_lesson: 'var olan dersi çoğalt',
    clone_lesson_sub:
      'Bu dersin benzersiz bir kopyasını oluştur; bu ders için yapılan değişiklikler orijinal dersi etkilemeyecektir.',
    clone_lesson_modal_sub:
      'Lütfen kursunuza eklemek istediğiniz dersin altındaki klonla(çoğalt) butonuna tıklayınız.'
  },

  management: {
    groups_title: 'Grupları Yönet',
    delete_warning: 'Emin misiniz?',
    organizations_title: 'Organizasyonlarım',
    organizations_subtitle: 'Listene organizasyon ekle',
    users_title: 'Kullanıcıları yönet',
    users_position: 'Kıdemli Hesap Yöneticisi',
    user_not_found: 'Kullanıcı bulunamadı',
    select_org:
      'Kullanıcıları yönetmek için lütfen bir organizasyon bulup seçin'
  },

  audio: {
    modal_title: 'Ses Ekle',
    list_view: 'Liste Görünümü',
    create_audio_modal_title: 'Ses Oluştur',
    edit_audio_modal_title: 'Ses Düzenle',
    public_audio_not_found: 'Ses bulunamadı.',
    private_audio_not_found: 'Henüz herhangi bir ses dosyası yüklemediniz',
    are_you_sure_to_delete: 'Silmek istediğinizden emin misiniz',
    type_something: 'Bir şey yaz',
    select_voice: 'Seç',
    file_name: 'Dosya adı',
    description: 'Tanım',
    topic: 'Konu',
    key_words_tag: 'Anahtar sözcük Etiketi',
    mp3_audio: 'MP3 Ses',
    created: 'Oluşturuldu',
    duration: 'Süre',
    close: 'kapat'
  },

  image: {
    modal_title: 'Resim Ekle',
    image: 'Resim',
    pixel: 'Piksel',
    dimension: 'Boyut',
    public_image_not_found: 'Resim bulunamadı.',
    private_image_not_found: 'Henüz herhangi bir Resim dosyası yüklemediniz'
  },

  annotation: {
    modal_title: 'Dipnot'
  },

  text: {
    modal_title: 'Metin Düzenleyici'
  },

  video: {
    modal_title: 'Video Ekle',
    image: 'Video',
    mp4_video: 'MP4 Video',
    public_video_not_found: 'Video bulunamadı',
    private_video_not_found: 'Henüz herhangi bir"video" dosyası yüklemediniz'
  },

  media: {
    title: 'Medya Kütüphanesi',
    subtitle: 'Dosyalarınızın kütüphanesi',
    modal_title: 'Medya yükle',
    delete_warning: 'Silmeyi onayla',
    delete_message: 'Silinen medya kullanıldığı sayfada yine de görünür olacak',
    dropzone_text: 'veya Sürükle ve Bırak',
    delete_success: 'Medya başarılı bir şekilde silindi',
    upload_file: 'Dosya yükle',
    drag_drop: 'veya Sürükle ve Bırak',
    import_file: 'Dosya(ları) bilgisayarınızdan içeri aktarın',
    no_media: 'Henüz herhangi bir medya dosyası yüklemediniz',
    media_type: 'Medya türü',
    video: 'Video',
    image: 'Resim',
    audio: 'Ses',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'Medya bulunamadı',
    of: 'ın',
    disclaimer: `Medyamın aşağıdakilere sebep olmayacağını garanti ederim:
    - herhangi bir üçüncü tarafın haklarını ihlal etmeyecek
  - herhangi bir yasadışı eylem barındırmayacak, gurur zedeleyici, müstehcen, uygunsuz, açık saçık, pornografik, şiddet içeren, küfürlü, aşağılayıcı, tehditkâr, ayrımcı içerikleri veya yıldız işareti ile gizlenmiş olsa dahi içermeyecek
  - diğer kişiler üzerine kişisel saldırıları barındırmayacak
  - diğer katılımcıların, halka mal olmuş kişilerin veya ünlülerin herhangi bir taklidini içermeyecek
  - kişinin rızası olmadan o kişiyle ilgili kayıtlar veya kişisel bilgiler barındırılmayacak ve dünyanın herhangi bir yerindeki verilerin korunması düzenlemeleri ihlal
  - herhangi bir ticari talebi veya “spam” şeklini barındırmayacak`
  },

  navigation: {
    account: 'Hesap',
    assessments: 'Değerlendirmeler',
    dashboard: 'Pano',
    groups: 'Grup Yönetimi',
    logout: 'Çıkış',
    organisations: 'Organizasyonlar',
    organizations_users: 'Organizasyonlar & Kullanıcılar',
    reports: 'Raporlar',
    schedule: 'Program',
    training: 'Alıştırma',
    users: 'Kullanıcılar',
    workshop: 'Atölyem',
    nowLive: 'canlı yayın'
  },

  onboarding: {
    step1_title: '1. Adım : Bize Biraz Kendinden Bahset',
    step1_subtitle: 'Adın nedir? Nerelisin? İş unvanınız nedir?',
    step2_title: '2. Adım : Geliştirebileceğin Birkaç Yetenek Seç',
    step2_subtitle:
      'Sonrasında bize neyi daha iyi anlamak istediğini söyle. Belki de henüz algılayamadığın bir şey? Yeni bir çalışma alanı? Sevdiğin kişi ne yapıyor?'
  },

  pagebuilder: {
    title: 'Ders Oluştur',
    subtitle:
      'Hedef kitlenizin sizden bir şeyler öğrenmesi için resimler, videolar veya infografikler gibi içerik oluşturma zamanı',
    select_layout: 'Sayfa Düzeni Seçin',
    template1: 'Boşluk',
    template2: 'Başlık & Altyazı',
    template3: 'Başlık & Metin',
    template4: 'Başlık , Medya & Metin',
    template5: 'Başlık & Medya',
    template6: 'Başlık & Quiz'
  },

  pageconstructor: {
    title: 'Dersi Oluştur ve Klonla',
    subtitle:
      'Hedef kitlenizin sizden bir şeyler öğrenmesi için resimler, videolar veya infografikler gibi içerik oluşturma zamanı'
  },

  passwordreset: {
    success_coded:
      'Verilen email adresine bir onaylama kodu gönderdik, lütfen aşağıdaki alandaki kodu yeni bir şifre koymak için kopyalayın.',
    success_changed:
      'Başarılı bir şekilde yeni şifre oluşturdunuz. Şimdi giriş yapabilirsiniz.'
  },

  placeholders: {
    search: 'Ara',
    answer: 'Cevapla',
    chat: 'Bir şey söyleyin...',
    code: 'Kod',
    criterion: 'Ölçütler',
    date_event: 'Tarih & saat seç',
    date_start: 'Başlangıç tarihi',
    date_expire: 'Son geçerlilik tarihi',
    description: 'Tanım',
    elements: 'Öğeleri sınıflandır',
    email: 'Email',
    feedback_correct: 'Geribildirim Doğru',
    feedback_incorrect: 'Geri bildirim Yanlış',
    host: 'Oturum Sahibi',
    keywords: 'Anahtar sözcük(ler) ara',
    lesson_description: 'Ders tanımı',
    location: 'Konum',
    minutes: 'Dakika',
    name: 'İsim',
    organiser: 'Yazar',
    organization: 'organizasyon',
    password: 'Şifre',
    phone: 'Telefon',
    photo: 'Fotoğraf',
    picture: 'Resim',
    point: 'Puan',
    position: 'Pozisyon',
    question: 'Soru',
    quiz: 'Quiz İsmi',
    search_course: 'Kurslarda Ara',
    search_media: 'Medya ara',
    search_name: 'Ada göre Ara',
    search_title: 'Başlığa göre Ara',
    search_training: 'Alıştırma Ara',
    settings: 'Ayarlar',
    tags: 'Etiketler',
    title: 'Başlık',
    topics: 'Konular',
    username: 'Kullanıcı adı',
    keyword: 'Anahtar kelimeler',
    max_500_characters: 'Maksimum 500 Karakter',
    no_description: 'Bu dosyanın tanımı bulunmamakta',
    no_keyword: 'Bu dosyanın anahtar kelimeleri bulunmamakta',
    no_topics: 'Bu dosyanın belli bir konusu bulunmamakta',
    feedback: 'Mesaj',
    contact: 'Nasıl yardımcı olabiliriz?'
  },

  publishsettings: {
    title: 'Yayınlama Ayarları',
    event_subtitle:
      'Ayarları etkinliğinize ekleyerek etkinliğinizi görüntüleyebilir veya etkileşime geçebilirsiniz',
    assessment_subtitile:
      'Değerlendirmenize isim verip hedef kitlenize ne öğrenmelerini beklediğinizi',
    course_subtitle:
      'Ayarları etkinliğinize ekleyerek etkinliğinizi görüntüleyebilir veya etkileşime geçebilirsiniz',
    disclaimer: `1.	Kayıt

  Bir kullanıcı olarak kayıt yaptırarak / bir hesap oluşturarak [Kullanıcı Sözleşmesi]’ni onaylıyor ve [Gizlilik İlkesi]’ni okuduğunuzu kabul ediyorsunuz



  2.	Kurs oluşturma

  Araçlarımızı kullanarak ve kurs içeriği oluşturarak [Kullanıcı Sözleşmesi]’ni onaylıyor ve [Gizlilik İlkesi]’ni okuduğunuzu kabul ediyorsunuz



  3.	Etkinlik oluşturma

  Araçlarımızı kullanarak ve etkinlik oluşturarak [Kullanıcı Sözleşmesi]’ni onaylıyor ve [Gizlilik İlkesi]’ni okuduğunuzu kabul ediyorsunuz


  4.	Değerlendirme oluşturma

  Araçlarımızı kullanarak ve değerlendirme oluşturarak [Kullanıcı Sözleşmesi]’ni onaylıyor ve [Gizlilik İlkesi]’ni okuduğunuzu kabul ediyorsunuz`,
    dates_validation_error: 'Her iki tarih de doldurulmalı.',
    emails_validation_error: 'Email listesi geçersiz.',
    specific_email_validation_error: 'Sadece bir emaile izin veriliyor.',
    i_agree_to_these: 'Bunlara katılıyorum ',
    terms_and_conditions: 'hüküm ve koşullar.',
    PublicDescription:
      'Ücretsiz bağımsız kullanıcılar: (Gizli ve halka açık seçenekler)Size ait [Kurs|Etkinlik|Değerlendirme] kaydedildi ve varsayılan durumu Gizli olarak ayarlandı. Bu da bu içeriği sadece siz görebilirsiniz demektir. Bu içeriği yayınlamak için halka açık hale getir seçeneğini seçebilirsiniz. Böylelikle kurs platformdaki herkese erişilebilir hale gelecek.',
    OrganisationsDescription:
      'Org kullanıcıları: (""Bitir"" yerine ""Yayınla""yı kullanın ve onları diğer kullanıcılar gibi fakat herhangi bir yayınlama seçeneği olmadan yayınlama sayfasına getirin.) Size ait [Kurs|Etkinlik|Değerlendirme] kaydedildi ve Gizli durumda. Böylelikle sadece siz ve organizasyonlarınızdaki yöneticiler bunu görebilir. Bir kullanıcı olarak, kendi organizasyonunuz içerisinde bunu kendi kendinize yayınlayamazsınız çünkü bu yönetici haklarını gerektirir. Lütfen Yöneticilerinizden biriyle irtibat kurun ve içeriğinizi herkese açık şekilde tüm organizasyonlara, organizasyonunuz içerisindeki özel gruplara veya özel kullanıcılara yayınlamasını isteyiniz.',
    OrganisationGroupsDescription:
      'Org Yöneticiler: (Bu organizasyon içerisinde yapılan içerikler için: Gizli, halka açık, organizasyon, gruplar, özel kullanıcılar):Bu [Kurs|Etkinlik|Değerlendirme] kaydedildi ve varsayılan olarak Gizli olarak ayarlandı. Bu da sadece sizin (ve içerik üreticisinin) bu içeriği görebileceği anlamına gelir. Bu içeriği yayınlamak için aşağıdaki seçeneklerden birini seçebilirsiniz. Kursunuzu Halka Açık şekilde yayınlayarak organizasyonunuza dışarıdan dahil olanlar da dahil olmak üzere platformdaki tüm kullanıcıların erişimine açık hale getiriyorsunuz. Organizasyona yönelik yayınlamak demek organizasyon içindeki tüm kullanıcılar bunu görebilecek demektir. 1 veya daha fazla grup için de yayınlayabilirsiniz ki bu da sadece o gruplar içerisindekilerin görebileceği anlamına gelir.  Son olarak, Sharelook hesaplarını ve email adreslerini kullanarak organizasyonunuzun içinden ve dışından özel kullanıcılara da yayın yapabilme seçeneğine sahipsiniz.',
    SpecificUsersDescription:
      'Ücretli Bağımsız Kullanıcılar: (gizli, halka açık özel kullanıcılar)Size ait [Kurs|Etkinlik|Değerlendirme] kaydedildi ve varsayılan durumu Gizli olarak ayarlandı. Bu da bu içeriği sadece siz görebilirsiniz demektir. Bu içeriği yayınlamak için aşağıdaki seçeneklerden birini seçebilirsiniz. Kursunuzu Halka Açık şekilde yayınlayarak platformda bulunan tüm kullanıcılara mevcut hale getiriyorsunuz. Özel Kullanıcı seçeneği kurslarınızı diğer Özel Kullanıcılarla Sharelook hesaplarıyla ilişkilendirilmiş email adreslerini kullanarak paylaşabilmenizi sağlayacak.'
  },

  quiz: {
    quiz_empty: 'Henüz bir quiz oluşturmadınız',
    questions_empty: 'Henüz bir soru oluşturmadınız'
  },

  regions: {
    asia_pacific_australia: 'Avustralya',
    asia_pacific_india: 'Hindistan',
    asia_pacific_japan: 'Japonya',
    asia_pacific_s_korea: 'Güney Kore',
    asia_pacific_singapore: 'Singapur',
    asia_pacific_taiwan: 'Tayvan',
    eu_belgium: 'Belçika',
    eu_germany: 'Almanya',
    eu_ireland: 'İrlanda',
    south_america_brazil: 'Brezilya',
    us_central_iowa: 'Iowa',
    us_east_s_carolina: 'Güney Carolina',
    us_east_virginia: 'Virginia',
    us_west_california: 'California',
    us_west_oregon: 'Oregon'
  },

  reports: {
    title: 'Raporlar'
  },

  signup: {
    success_step1:
      'Verilen email adresine bir Doğrulama kodu gönderdik, lütfen aşağıdaki alandaki kodu kaydınızı onaylamak için kopyalayın.',
    success_step2: 'Teşekkürler. Başarılı bir şekilde kaydoldunuz.',
    privacy: `Sharelook'un <1> hüküm & koşullarını </1> ve <3> gizlilik ilkelerini </3>kabul ediyorum`
  },

  stream: {
    emotion_impressive: 'Etkileyici',
    emotion_unimpressive: 'Etkileyici değil',
    message_not_started: 'Çok Yakında',
    message_running: 'Canlı',
    message_processing:
      'Şu anda canlı kaydı banttan çalmak için işlem yapıyoruz. Videoyu görüntülemek ve derecelendirme ve geri bildirim eklemeye devam etmek için daha sonra tekrar kontrol edin'
  },

  tabs: {
    audience: 'Hedef Kitle',
    course: 'Kurs Genel Bakış',
    details: 'Canlı Etkinlik Detayları',
    description: 'Tanım',
    host: 'Oturum Sahibi',
    lesson: 'Ders Genel Bakış',
    lessons: 'Dersler',
    overview: 'Genel Bakış',
    page: 'Sayfa Oluşturucu',
    publish: 'Yayınla',
    settings: 'Yayınlama Ayarları',
    total_views: 'Toplam Görüntülemeler',
    live_participates: 'Canlı Katılımcılar',
    live_chats: 'Canlı Sohbetler',
    live_quiz: 'Canlı Anketler',
    trainer_rating: 'Alıştırma Derecesi',
    trainer_times: 'Alıştırma Zamanları',
    courses_quizzes: 'Kurs Quizleri',
    user_list: 'Kullanıcı Listesi',
    discussion: 'Tartışma',
    notes: 'Notlarım'
  },

  topics: {
    SALES_TRAINING: 'Satış Eğitimi',
    NEGOTIATION_TRAINING: 'Pazarlık Eğitimi',
    CROSS_CULTURAL_AWARENESS: 'Kültürler Arası Farkındalık',
    NETWORKING_SKILLS: 'Örgülenim Yetenekleri',
    SOFTWARE_ARCHITECTURE: 'Yazılım Mimarisi',
    PROJECT_MANAGEMENT: 'Proje Yönetimi',
    DIGITAL_TRANSFORMATION: 'Dijital Dönüşüm',
    IT_CONSULTING: 'IT Danışmanlığı',
    MANAGEMENT_CONSULTING: 'Yönetim Danışmanlığı',
    HR_CONSULTING: 'HR Danışmanlığı',
    INTERNET_OF_THINGS: 'Nesnelerin İnterneti (IoT)',
    CYBERSECURITY: 'Siber güvenlik',
    PRIVACY_AND_GDRP: 'Gizlilik ve GVKP(Genel Veri Koruma Tüzüğü)'
  },

  training: {
    title: 'Alıştırma',
    title_assessment: 'Değerlendirmeler',
    subtitle: 'Kurslar ve Canlı Etkinlikler',
    enrolled_title: 'Kaydolunmuş Kurslar ve Canlı Etkinlikler',
    enrolled_subtitle: 'Kurslar ve Kaydolduğunuz Canlı Etkinlikler',
    enrolled_message:
      'Şu anda herhangi bir kurs ve etkinliğe kayıtlı değilsiniz.',
    past_live_event_title: 'Geçmiş Canlı Etkinlikler',
    past_live_event_subTitle: 'Bitmiş Canlı Etkinlikler',
    past_live_event: 'Şu anda hiç geçmiş canlı bir etkinlik bulunmamakta.',
    recomended_title: 'Tavsiye Edilen Kurslar ve Canlı Etkinlikler',
    now_live_event_title: 'Şimdi Canlı',
    now_live_event_subTitle: 'Canlı veya yakında canlı olacak etkinlikler',
    now_live_event: 'Şu anda canlı bir etkinlik bulunmamakta.',
    webinar_event_title: 'Web Seminer Kanalı',
    webinar_event_subTitle: 'Bitmiş Web Seminerleri',
    webinar_event: 'Şu anda web semineri bulunmamakta.',
    p2p_event_title: 'Koçluk Oturumları',
    p2p_event_subTitle: 'Bitmiş Koçluk Oturumu',
    p2p_event: 'Şu anda hiç koçluk oturumu bulunmamakta.',

    now_live_assessment_title: 'Şimdi Canlı',
    now_live_assessment_subTitle:
      'Canlı veya yakında canlı olacak değerlendirmeler',
    now_live_assessment_message:
      'Şu anda hiç canlı bir değerlendirme bulunmamakta.',

    upcoming_assessment_title: 'Yaklaşan Canlı Değerlendirme',
    upcoming_assessment_subtitle: 'Yaklaşan Canlı Değerlendirme',
    upcoming_assessment_message:
      'Şu anda gelecek canlı bir değerlendirme bulunmamakta.',

    past_live_assessment_title: 'Geçmiş Canlı Değerlendirmeler',
    past_live_assessment_subTitle: 'Bitmiş Canlı Değerlendirmeler',
    past_live_assessment_message:
      'Şu anda hiç geçmiş canlı değerlendirmeler bulunmamakta.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      '<0><0/></0>’ıza bağlı olarak kurslar ve canlı etkinlikler düzenledik',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Alıştırma Ara',
    search_assessment: 'Değerlendirme Ara',
    recomended_message:
      'Şu anda tavsiye edilen bir kurs veya etkinlik bulunmamakta.'
  },

  warnings: {
    delete: 'Emin misiniz?'
  },

  workshop: {
    title: 'Atölyem',
    subtitle: 'Bir kurs oluşturun veya kendi canlı etkinliğinize sahiplik edin',
    new_course: 'Yeni bir kurs oluştur',
    new_event: 'Yeni bir canlı etkinlik oluştur',
    new_assessment: 'Yeni bir canlı değerlendirme oluştur',
    courses_title: 'Oluşturulan Kurslar& Canlı Etkinlikler',
    courses_subtitle:
      'Oluşturulan kursunuzu Düzenle & Yayınla ve canlı etkinlikleri planla ',
    tags_course: 'Kurs',
    tags_live: 'Canlı etkinlik',
    tags_assessment: 'Canlı Değerlendirme'
  },

  help_center: {
    sidebar: {
      title: 'Size nasıl yardımcı olabiliriz?',
      back_to: 'Pano'
    },
    menu: {
      help_center: 'Yardım Merkezi',
      whats_new: 'Yenilikler',
      feedback: 'Geri bildirim',
      feedback_title: 'Sharelook’a geri bildirim gönder',
      terms_and_conditions: 'Hüküm & Koşullar',
      privacy_policy: 'Gizlilik İlkesi',
      contact_us: 'Bizimle irtibat kurun'
    },
    get_started: {
      title: 'Sharelook ile harekete geçin',
      description: {
        main:
          'CANLI VİDEOYU KULLANIMI KOLAY KURS OLUŞTURUCULARINA ENTEGRE ETTİK',
        tagline:
          'ShareLook’un patentli canlı yayın sistemi ile etkileşim yaratabilir, öğrenmeyi otomatikleştirebilir ve bilgi paylaşımını en üst düzeye çıkarabilirsiniz.'
      }
    },
    whats_new: {
      title: 'Sharelook ile harekete geçin',
      description: {
        main:
          'Hikaye anlatıcılığı tarzı öğrenmenin oluşturulmasının kısa sürede yaratılabileceğini ve çok pahalı olmadığını biliyor muydunuz?  ShareLook kurs oluşturucusunu ve ilgili yetenekleri birleştirmelisiniz. "NASIL olduğunu sorabilirsiniz',
        tagline: ''
      }
    },
    create_workshop: 'Nasıl Atölye oluşturulur',
    create_course: 'Nasıl Kurs oluşturulur',
    create_user: 'Nasıl Kullanıcı oluşturulur',
    create_group: 'Nasıl Grup oluşturulur',
    create_webinar: 'Nasıl Web Semineri oluşturulur',
    create_live_event: 'Nasıl Canlı Etkinlik oluşturulur',
    create_live_assessment: 'Nasıl Canlı Değerlendirme oluşturulur',
    create_live_on_mobile: 'Mobilde Canlı Bağlantı Oluştur',
    personalize_profile: 'Profili kişiselleştir',
    manage_group: 'Grubu Yönet',
    report: 'Rapor',
    add_annotations: 'Dipnot/Açılır Pencere Nasıl Eklenir',
    add_audio: 'Ses Nasıl Eklenir',
    add_header_and_footer: 'Başlık ve Alt Bilgi Ekleme',
    add_image: 'Resim Nasıl Eklenir',
    add_quiz_content: 'Quiz İçeriği Nasıl Eklenir',
    add_text_content: 'Metin İçeriği Nasıl Eklenir',
    add_user: 'Kullanıcı Nasıl Eklenir',
    add_video: 'Video Nasıl Eklenir',
    clone_course: 'Kurs Nasıl Çoğaltılır',
    find_live_broadcast: 'Canlı Yayın Nasıl Bulunur',
    contact_us: {
      title: 'Bizimle irtibat kurun',
      subject_placeholder: 'Bir konu girin*',
      content_placeholder: 'Bir mesaj girin*',
      subject_required: '*Konu gerekli',
      content_required: '*Mesaj gerekli',
      submit: 'Gönder',
      cancel: 'İptal Et',
      sent: 'Gönderildi'
    },
    feedback: {
      title: 'Sharelook’a geri bildirim gönder',
      attach_title: 'Bir dosya ekle',
      choose: 'Dosya seç',
      detail: 'Dosya destek ekibiyle paylaşılacak',
      content_placeholder: 'Bir mesaj girin*',
      content_required: '*Mesaj gerekli',
      submit: 'Gönder',
      cancel: 'İptal Et',
      sent: 'Gönderildi'
    }
  },
  discussion: {
    join_discussion: 'Tartışmaya katılın'
  },
  notes: {
    title: 'Notlarım',
    add_note: 'Yeni not ekle'
  }
}
